// Default V5 Scripts. Navigation, interactivity, etc...

// Any functions wrapped in this event listener will execute once the DOM is ready.

// If you're reading this, the old JQuery $(document).ready(function() { ... }); still exists too.
window.addEventListener("DOMContentLoaded", () => {

  // site-wide
  calcHeaderOffset();
  placeOrderOverlayText();
  pinMobileSearch();

  // add CSS class to body tag to distinguish browser
  getUserAgent();

  // lazy load all images that have class of "lazy"
  lazyLoadImages();

  // checking for perq, podium or livehelpnow
  checkForThirdPartyChat();

  // Iniialize serach suggestions
  initializeSearchSuggestions();

  // catalog page
  const catalogPage = document.querySelector(".catalogProductDisplay");
  if (catalogPage) {
    // initialize product filters
    productFilters.init();

    // filter accordion
    initializeAccordion();

    // monthly payment plan modal
    catalogModal();

    // lazy load ATP widget availability data
    loadATPWidgetData();

    // fill in the product listing if the initial render left it pending
    fetchProductListing();

    // fill in result count/pagination if the initial render left it pending -
    // fires alongside fetchProductListing() above, since neither has a data
    // dependency on the other
    fetchCatalogCount();

    // fill in any facets the initial render left as pending placeholders
    fetchDeferredFacets();
  }

  // product page
  const productPage = document.querySelector(".single-product");
  if (productPage) {
    // swiperjs for product images
    initializeProductPageSwipers();

    // product info accordion
    initializeAccordion();

    // product reviews
    productReviews.init();

    // protection plan features
    applyProtectionPlanProductPage();
    removeProtectionPlanProductPage();
    slidePanelProtectionPlanProductPage();

    // customize it button
    initializeCustomizeItButton();

    // ATP widget: swap between local-stock and ETA messaging based on
    // the selected quantity vs locally-available stock.
    initATPWidgetQtyToggle();
  }

  // brand catalog page
  const brandCatalogPage = document.querySelector(".brandContentContainer");
  if (brandCatalogPage) {
    // init narrow by filters
    brandPageNarrowBy();
  }

  // contact us page
  const contactPage = document.querySelector(".page-contact-us");
  if (contactPage) {
    // toggle location list on mobile
    toggleLocationsList();
  }

  // staff page
  const staffPage = document.querySelector(".page-staff");
  if (staffPage) {
    // staff page read more button accordion
    staffPageReadMore();
  }

  const zeclinerPage = document.querySelector(
    "[class^='page-zecliner'], [class*=' page-zecliner']"
  );
  if (zeclinerPage) {
    // initialize zecliner swiper
    initializeZeclinerSwiper();
    // initialize zecliner feature slider
    initializeZeclineFeaturesSlider();
  }

  // Construct a new ProductAR instance for Ashley products
  new ProductAR(".view-in-ar");
  // Design Studio: Find Your Style page
  const styleQuizPage =
    document.querySelector(".page-find-your-style") ||
    document.querySelector(".page-style-quiz-results");
  if (styleQuizPage) {
    const styleQuiz = new StyleQuiz();
    styleQuiz.init();
  }

  // Design Studio: Design Project form page
  const designProjectPage = document.querySelector(
    ".page-start-design-project"
  );
  if (designProjectPage) {
    const designProject = new DesignProjectForm();
    designProject.init();
  }

  //Initiate zip code class
  const zipCodeChanger = new ZipCodeChanger();
  zipCodeChanger.init();

  const printPageButton = document.querySelector(".printPage");
  if (printPageButton) {
    printPageButton.addEventListener("click", (event) => {
      window.print();
    });
  }

  // Add to wishlist button click (delegated to handle Swiper cloned slides)
  document.body.addEventListener("click", function (e) {
    const btn = e.target.closest(".wishButton");
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains("inWishlist")) {
      removeFromWishlist(btn.dataset.item);
      return;
    }
    const item = btn.dataset.item;
    const wishlistUnderlay = document.querySelector(".wishlistUnderlay");
    if (wishlistUnderlay) {
      wishlistUnderlay.style.display = "block";
      wishlistUnderlay.addEventListener("click", function (e) {
        if (e.target.classList.contains("wishlistUnderlay")) {
          this.style.display = "none";
        }
      });
      document.querySelectorAll(".wishlistOption").forEach((option) => {
        option.dataset.item = item;
      });
      document.querySelector(".wishlistMessage").style.display = "none";
    } else {
      addToWishlist(item, "");
    }
  });

  // Add to specific wishlist button click
  const wishlistOptions = document.querySelectorAll(".wishlistOption");
  if (wishlistOptions.length > 0) {
    wishlistOptions.forEach((option) => {
      option.addEventListener("click", function () {
        const item = this.dataset.item;
        const wishlist = this.dataset.wishlist;
        addToWishlist(item, wishlist);
      });
    });
  }

  // Remove from wishlist button click
  const removeFromWishlistButtons = document.querySelectorAll(
    ".wishlistContainer .removeButton"
  );
  if (removeFromWishlistButtons.length > 0) {
    removeFromWishlistButtons.forEach((btn) => {
      btn.addEventListener("click", async function (e) {
        e.preventDefault();
        const item = this.dataset.item;
        const wishlist = this.dataset.wishlist;
        const data = "wishlist=" + wishlist + "&item=" + item;

        const response = await fetch(
          globalObject.url + "ajax/account.php?action=wishlist-remove&" + data,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: data,
          }
        );

        const success = await response.json();

        if (success) {
          window.location.reload();
        }
      });
    });
  }

  toggleFiltersOnMobile();
  handleSortingBarChange();
  handlePaginationClick();
  handleCloseModal();
  product360Viewer();
  handleTestimonialsStars();
});

// The following gets the user-agent and platform and adds them as data attributes to the html element. We use this currently to hide the magnifying glass in the search bar on
// old brick when viewed on iPad or iPhone since they display their own icon in input type=search elements, but it could be used for other things as well.
const docEl = document.documentElement;
docEl.setAttribute("data-useragent", navigator.userAgent);
docEl.setAttribute("data-platform", navigator.platform); // navigator.platform is deprecated but still supported by all browsers. If this ever stops working here is the culprit.
docEl.className +=
  !!("ontouchstart" in window) || !!"onmsgesturechange" in window
    ? "touch"
    : "";

var formatPrice = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

/**
 * ProductAR class handles the integration of Augmented Reality (AR) features for Ashely products.
 * It manages the display and functionality of AR buttons, QR codes, and 3D models based on the product SKU.
 *
 * @class ProductAR
 * @param {HTMLElement|string} elm - The HTML element or selector for the product container.
 */
class ProductAR {
  constructor(elm) {
    this.elm =
      elm instanceof HTMLElement ? elm : document.querySelector(elm) || null;
    if (!this.elm) return;

    this.clientUrl = globalObject.url;

    this.sku = this.elm.dataset.sku || null;
    this.inRoomButton = document.getElementById("in-room") || null;
    this.qrInRoomButton = document.getElementById("qr-in-room") || null;
    this.in3dButton = document.getElementById("in-3d") || null;
    this.modelViewer = document.getElementById("model-viewer") || null;
    this.pregenerated = new MxtWebAR.MxtWebArPregenerated({
      apiKey: "AIzaSyDnPvID8qhKrITVGePACdp1cZ1zCM8lkm8",
      clientId: "000002",
    });

    if (this.qrInRoomButton) {
      this.qrInRoomButton.addEventListener("click", () => {});
    }

    this.checkForWebArAsset(this.sku);
  }

  checkForWebArAsset = async (sku) => {
    const browserArType = MxtWebAR.MxtWebArHelpers.browserArSupport();
    try {
      const arAssetsAvailable = await this.pregenerated.getAssetTypesAvailable(
        sku
      );
      if (arAssetsAvailable.length === 0) {
        console.log(
          "Web AR Assets would work in this browser, but we don't have any!"
        );
        return;
      } else if (arAssetsAvailable.includes(browserArType)) {
        this.showArButtons();
      } else {
        this.showQrArButtons();
        console.log("CANT USE WEB AR IN THIS BROWSER");
      }
    } catch (e) {
      console.error("Failed to check if sku has web ar asset", e);
    }
  };

  addHrefToArButton = async (sku, button) => {
    try {
      const url = await this.pregenerated.getWebArPregeneratedUrl(sku, 1024);
      button.href = url;
    } catch (e) {
      console.log("Failed to get sku web ar asset", e);
      return false;
    }
  };

  getGlbModel = async (sku) => {
    try {
      const url = await this.pregenerated.getGlb(sku, 1024);
      this.modelViewer.src = url;
    } catch (e) {
      console.log("Failed to get sku web ar asset", e);
      return false;
    }
  };

  showQrArButtons = () => {
    if (this.qrInRoomButton) {
      this.qrInRoomButton.classList.remove("d-none");

      new QRious({
        size: 300,
        element: document.getElementById("qr"),
        value: `${this.clientUrl}ar-viewer?sku=${this.sku}&lod=1024`,
      });
    }
    if (this.in3dButton) {
      this.in3dButton.classList.remove("d-none");
      this.getGlbModel(this.sku, this.in3dButton);
    }
  };

  showArButtons = () => {
    if (this.inRoomButton) {
      this.inRoomButton.classList.remove("d-none");
      this.addHrefToArButton(this.sku, this.inRoomButton);
    }
    if (this.in3dButton) {
      this.in3dButton.classList.remove("d-none");
      this.getGlbModel(this.sku);
    }
  };
}

/**
 * Class representing the Zecliner feature slider.
 * @class
 */
class ZeclinerFeatureSlider {
  /**
   * Create a ZeclinerFeatureSlider.
   * @param {HTMLElement} container - The container element for the slider.
   */
  constructor(container) {
    this.container = container;
    this.slides = container.querySelectorAll(".slide");
    this.activeSlide = container.querySelector(".slide.active");
    this.activeText = container.querySelector(".text-container.active");
    this.nextButton = container.querySelector(".next-slide-btn");

    this.init();
  }

  init() {
    // Add click event listener to each slide
    this.slides.forEach((slide) => {
      slide.addEventListener("click", () => {
        this.handleSlideClick(slide);
      });
    });

    // Add click event listener to the next button
    this.nextButton.addEventListener("click", () => {
      this.handleNextButtonClick();
    });
  }

  /**
   * Handle the click event for a slide.
   * @param {HTMLElement} slide - The clicked slide element.
   */
  handleSlideClick(slide) {
    // Check if the clicked slide is not the currently active slide
    if (slide !== this.activeSlide) {
      this.removeActiveClasses();
      this.addActiveClasses(slide);
    }
  }

  /**
   * Handle the click event for the next button.
   */
  handleNextButtonClick() {
    this.removeActiveClasses();

    // Determine the next slide to activate
    const nextSlide =
      this.activeSlide.nextElementSibling &&
      this.activeSlide.nextElementSibling.classList.contains("slide")
        ? this.activeSlide.nextElementSibling
        : this.slides[0];

    this.addActiveClasses(nextSlide);
  }

  /**
   * Remove the active classes from the currently active slide and text container.
   */
  removeActiveClasses() {
    this.activeSlide.classList.remove("active");
    this.activeText.classList.remove("active");
  }

  /**
   * Add the active classes to the specified slide and its corresponding text container.
   * @param {HTMLElement} slide - The slide element to activate.
   */
  addActiveClasses(slide) {
    this.activeSlide = slide;
    this.activeText = this.container.querySelector(
      `.text-container.${slide.className.split(" ")[1]}`
    );
    this.activeSlide.classList.add("active");
    this.activeText.classList.add("active");
  }
}

/**
 * Initialize the ZeclinerFeatureSlider if the container element is found.
 */
const initializeZeclineFeaturesSlider = () => {
  const featuresContainer = document.querySelector(
    ".zecliner-features .content-container"
  );
  if (featuresContainer) {
    new ZeclinerFeatureSlider(featuresContainer);
  }
};

// Zecliner landing page swiper
function initializeZeclinerSwiper() {
  const swiper = new Swiper(".zecliner-swiper .swiper", {
    loop: true,
    slidesPerView: 1,
    autoplay: true,
    navigation: {
      nextEl: ".zecliner-swiper .swiper-button-next",
      prevEl: ".zecliner-swiper .swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    pagination: {
      el: ".zecliner-swiper .swiper-pagination",
    },
  });
}

// Product Page Image Swipers
function initializeProductPageSwipers() {
  let thumbsSwiper = null;
  let mainSwiper = null;
  let driftInstances = [];

  function getThumbDirection() {
    return window.innerWidth >= 1200 ? "vertical" : "horizontal";
  }

  function preserveDriftZoomAspectRatio(drift, triggerImg) {
    const zoomPane = drift && drift.zoomPane;
    if (!zoomPane || typeof zoomPane._setImageSize !== "function") return;

    const originalSetImageSize = zoomPane._setImageSize.bind(zoomPane);

    const applyNaturalSize = (triggerWidth, triggerHeight) => {
      const naturalWidth = zoomPane.imgEl && zoomPane.imgEl.naturalWidth;
      const naturalHeight = zoomPane.imgEl && zoomPane.imgEl.naturalHeight;
      if (!naturalWidth || !naturalHeight) return;

      const zoomFactor = (zoomPane.settings && zoomPane.settings.zoomFactor) || 3;
      const scale = zoomFactor * Math.max(triggerWidth / naturalWidth, triggerHeight / naturalHeight);

      zoomPane.imgEl.style.width = `${Math.round(naturalWidth * scale)}px`;
      zoomPane.imgEl.style.height = `${Math.round(naturalHeight * scale)}px`;
    };

    zoomPane._setImageSize = function (triggerWidth, triggerHeight) {
      originalSetImageSize(triggerWidth, triggerHeight);
      applyNaturalSize(triggerWidth, triggerHeight);
    };

    zoomPane.imgEl.addEventListener("load", () => {
      const triggerWidth = triggerImg.clientWidth || triggerImg.naturalWidth || 0;
      const triggerHeight = triggerImg.clientHeight || triggerImg.naturalHeight || 0;
      if (!triggerWidth || !triggerHeight) return;
      applyNaturalSize(triggerWidth, triggerHeight);
    });
  }

  function createSwipers() {
    const numbThumbs = document.querySelectorAll(
      ".swiper-thumb-images .swiper-slide"
    ).length;

    if (numbThumbs > 1) {
      thumbsSwiper = new Swiper(".swiper-thumb-images", {
        loop: true,
        spaceBetween: 10,
        slidesPerView: "auto",
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        direction: getThumbDirection(),
      });
    }

    mainSwiper = new Swiper(".swiper-main-image", {
      loop: true,
      spaceBetween: 10,
      touchReleaseOnEdges: true,
      zoom: {
        enabled: true,
        containerClass: "swiper-zoom-container-mobile",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      ...(thumbsSwiper ? { thumbs: { swiper: thumbsSwiper } } : {}),
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      on: {
        slideChange: function () {
          if (thumbsSwiper) {
            thumbsSwiper.slideToLoop(this.realIndex);
          }
        },
      },
    });

    // Initialize Drift zoom on desktop
    const mainImages = document.querySelectorAll(
      ".swiper-main-image .swiper-slide:not(.swiper-video):not(.swiper-spin360) img"
    );
    mainImages.forEach((img) => {
      if (window.innerWidth > 768) {
        const drift = new Drift(img, {
          paneContainer: document.querySelector('.swiper-main-image'),
          inlinePane: false,
          // Keep high-detail zoom source while preserving its native aspect ratio.
          sourceAttribute: 'data-zoom',
        });

        preserveDriftZoomAspectRatio(drift, img);
        driftInstances.push(drift);
      }
    });
  }

  function destroySwipers() {
    driftInstances.forEach((d) => d.destroy());
    driftInstances = [];
    if (mainSwiper) { mainSwiper.destroy(true, true); mainSwiper = null; }
    if (thumbsSwiper) { thumbsSwiper.destroy(true, true); thumbsSwiper = null; }
  }

  createSwipers();

  // Reinitialize swipers when crossing the 1200px breakpoint
  let wasDesktop = window.innerWidth >= 1200;
  let resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      const isDesktop = window.innerWidth >= 1200;
      if (isDesktop !== wasDesktop) {
        wasDesktop = isDesktop;
        destroySwipers();
        createSwipers();
      }
    }, 250);
  });
}

const productReviews = {
  init: function () {
    //Containers
    this.container = document.querySelector("section.reviews");
    this.sortSelect = document.querySelector("select[name=reviews-sort]");
    if (!this.container || !this.sortSelect) return;

    this.header = this.container.querySelector("header.reviews-header");
    this.list = this.container.querySelector(".reviews-list");
    this.sort = this.list?.querySelector(".sort-results") || null;
    this.showing = this.sort?.querySelector(".showing") || null;
    this.filters = this.sort?.querySelector(".filters") || null;
    this.pagination = this.list?.querySelector(".pagination") || null;
    this.ratingSelect = this.header?.querySelector("input[name=rating-select]") || null;

    //Get page
    this.pageSplit = window.location.pathname.split("/");
    this.currentPage = this.pageSplit[this.pageSplit.length - 1];
    this.directory = this.pageSplit[this.pageSplit.length - 2];
    this.inventoryType = "";
    if (this.directory == "clearance" || this.directory == "outlet") {
      this.inventoryType = this.directory;
    }
    this.rawPage =
      this.currentPage.length != 0
        ? this.currentPage.replace("shop-", "")
        : "index";

    //Get product
    this.variantId = document.querySelector("section.variant")
      ? document
          .querySelector("section.variant")
          .getAttribute("id")
          .split("-")[1]
      : 0;

    //Functions
    this.handleSort();
    this.handleShowMore();
    this.handleShowLess();
    this.handleRatingClick();
    this.handleHelpfulRating();
  },
  handleSort: function () {
    //Sorting
    productReviews.sortSelect.addEventListener("change", function () {
      //Display
      productReviews.updateDisplay("sort");
    });
  },
  handleShowMore: function () {
    //Show next 5
    productReviews.pagination
      .querySelector(".show-more button")
      .addEventListener("click", () => {
        //Display
        productReviews.updateDisplay("append");
      });
  },
  handleShowLess: function () {
    //Show less
    productReviews.pagination
      .querySelector(".show-less button")
      .addEventListener("click", () => {
        //Display
        productReviews.updateDisplay("less");
      });
  },
  handleRatingClick: function () {
    //Show selected star rating
    productReviews.header
      .querySelectorAll(".breakdown li, .breakdown button.label")
      .forEach((el) => {
        el.addEventListener("click", () => {
          let button = el.querySelector("button.label");
          productReviews.header
            .querySelectorAll(".breakdown li")
            .forEach((el) => {
              el.classList.remove("selected");
            });
          el.classList.add("selected");
          //Update hidden input
          productReviews.ratingSelect.value = button.value;
          //Display
          productReviews.updateDisplay("rating");
        });
      });
  },
  handleFilters: function () {
    //Show selected star rating
    productReviews.filters
      .querySelector("button.clear-filters")
      .addEventListener("click", () => {
        //Update hidden input
        productReviews.ratingSelect.value = 0;
        //Remove selected from star rating
        productReviews.header
          .querySelectorAll(".breakdown li")
          .forEach((el) => {
            el.classList.remove("selected");
          });
        //Display
        productReviews.updateDisplay("clear");
      });
  },
  handleHelpfulRating: function () {
    //Helpful
    productReviews.list
      .querySelectorAll(".helpful-rating button")
      .forEach((el) => {
        el.addEventListener("click", () => {
          let reviewId = el.closest("li").id.split("_")[1];
          productReviews.updateHelpful(reviewId, el.dataset.value);
        });
      });
  },
  updateDisplay: function (method) {
    // Get sort by
    let sortBy = this.sortSelect.value;
    // Get offset
    let offsetText = parseInt(
      productReviews.showing.querySelector(".count-showing").textContent
    );
    let offset = method === "append" ? offsetText : 0;
    // Get star rating selection
    let rating = productReviews.ratingSelect.value;
    // Update display
    let data = {
      action: "getReviews",
      page: productReviews.rawPage,
      variantId: productReviews.variantId,
      inventoryType: productReviews.inventoryType,
      sortBy: sortBy,
      offset: offset,
      rating: rating,
    };


    fetch(globalObject.url + "ajax/product-catalog.php", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // $.ajax({
        //   data: data,
        //   type: "GET",
        //   url: globalObject.url + "ajax/product-catalog.php",
        //   dataType: "json",
        //   success: function (response) {
        // if (response) {
        let html = "",
          reviews = response.reviews,
          count = reviews.length,
          total = response.total;
        // console.log(reviews);
        //Get helpful cookies
        let getCookies = getCookie("reviews"),
          cookies = { helpful: [], notHelpful: [] };
        if (getCookies.length) {
          cookies = JSON.parse(getCookies);
        }
        //Remove scrolling index before adding it below
        const scrollContainer =
          productReviews.list.querySelector("li.scroll-here");
        if (scrollContainer) scrollContainer.classList.remove("scroll-here");
        //Get reviews
        let loop = 0;
        reviews.forEach((review) => {
          html +=
            '<li id="review_' +
            review.id +
            '" class="' +
            (loop == 0 ? " scroll-here" : "") +
            '">';
          html += "<article>";
          html += '<header class="customer-info">';
          html += '<p class="name"><strong>' + (review.name ?? 'Anonymous') + "</strong></p>";
          html += '<p class="location">' + (review.location ?? 'Anonymous') + "</p>";
          html += "</header>";
          html += '<div class="review-content">';
          html += '<div class="data">';
          html += review.stars;
          html += '<p class="date">' + (review.dateDisplay ?? '') + "</p>";
          html += "</div>";
          html += '<div class="content">' + (review.content ?? '') + "</div>";
          html += "</div>";
          html += '<div class="helpful-rating">';
          html += "<p>Was this helpful?</p>";
          html += '<div class="helpful-thumbs">';
          let helpful =
            cookies.helpful.indexOf(review.id) !== -1 ? true : false;
          let notHelpful =
            cookies.notHelpful.indexOf(review.id) !== -1 ? true : false;
          helpful == true
            ? getSVGIcon(
                "thumbs-up",
                "",
                "#review_" + review.id + " .thumbs-up"
              )
            : getSVGIcon(
                "thumbs-o-up",
                "",
                "#review_" + review.id + " .thumbs-up"
              );
          html +=
            '<button type="button" data-value="helpful" class="thumb helpful"' +
            (helpful == true || notHelpful == true ? " disabled" : "") +
            '><i class="thumbs-up"></i> <span class="count">' +
            review.helpful +
            "</span></button>";

          notHelpful == true
            ? getSVGIcon(
                "thumbs-down",
                "",
                "#review_" + review.id + " .fa-thumbs-down"
              )
            : getSVGIcon(
                "thumbs-o-down",
                "",
                "#review_" + review.id + " .fa-thumbs-down"
              );
          html +=
            '<button type="button" data-value="notHelpful" class="thumb notHelpful"' +
            (helpful == true || notHelpful == true ? " disabled" : "") +
            '><i class="' +
            (notHelpful == true ? "fas" : "far") +
            ' fa-thumbs-down" aria-hidden="true"></i> <span class="count">' +
            review.notHelpful +
            "</span></button>";
          html += "</div>";
          html += "</div>";
          html += "</article>";
          html += "</li>";
          loop++;
          //Only show 5 at a time
          if (loop >= 5) {
            return false;
          }
        });
        //Determine review display type
        switch (method) {
          case "sort":
          case "less":
          case "rating":
          case "clear":
            //Clear out container & reset html
            productReviews.list.querySelector("ul.reviews").innerHTML = html;
            //Scroll to the top of the review list
            // $("html, body").animate(
            //   {
            //     scrollTop:
            //       productReviews.list.getBoundingClientRect().top - 50,
            //   },
            //   200,
            // );
            productReviews.list.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            //Remove applied filters
            productReviews.filters.innerHtml = "";
            break;
          case "append":
            //Append reviews to existing container
            productReviews.list.querySelector("ul.reviews").innerHTML = html;
            //Scroll to the top of the first item loaded
            // $("html, body").scrollTop(
            //   productReviews.list.find("li.scroll-here").offset().top - 50,
            // );
            productReviews.list.scrollTo({
              top: 0,
              behavior: "smooth",
            });
            break;
        }
        //Update showing amounts
        //let showingAmount = method == 'append' ? (count < 5 ? total : offset + 5) : 5; //Add 5 to display accurate "showing" amount if appending
        let showingAmount = count < 5 ? total : offset + 5; //Add 5 to display accurate "showing" amount if appending
        productReviews.showing.querySelector(".count-showing").innerText =
          showingAmount;
        //Update totals
        productReviews.showing.querySelector(".count-total").innerText = total;
        productReviews.pagination.querySelector(".showing-all").innerText =
          "Showing all " + total + " review" + (total > 1 ? "s" : "");
        //Update showing buttons if no more reviews to show
        if (count < 5 || showingAmount == total) {
          productReviews.pagination
            .querySelector(".show-more")
            .classList.add("d-none");
          productReviews.pagination
            .querySelector(".showing-all")
            .classList.remove("d-none");
        } else {
          productReviews.pagination
            .querySelector(".show-more")
            .classList.remove("d-none");
          productReviews.pagination
            .querySelector(".showing-all")
            .classList.add("d-none");
        }
        //Update amount in showing buttons
        let showMoreAmount =
          total - showingAmount <= 5 ? total - showingAmount : 5;
        productReviews.pagination.querySelector(".show-more button").innerHtml =
          'Show <span class="count-more">' +
          showMoreAmount +
          " more review" +
          (showMoreAmount > 1 ? "s" : "") +
          ' <span class="svg-icon"><svg viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"/></svg></span>';
        //Display show less button when 5 or more reviews are showing
        if (count <= 5 && total >= 5) {
          productReviews.pagination
            .querySelector(".show-less")
            .classList.remove("d-none");
        } else {
          productReviews.pagination
            .querySelector(".show-less")
            .classList.add("d-none");
        }
        //Display filters
        let displayFilters = rating != 0;
        if (displayFilters) {
          productReviews.filters.classList.remove("d-none");
          let filters = [];
          if (rating != 0) {
            filters.push(
              '<li class="rating">with "' +
                rating +
                " star" +
                (parseInt(rating) > 1 ? "s" : "") +
                '"</li>'
            );
          }
          if (filters.length > 0) {
            //Get all filters & display
            let html = "<ul>";
            filters.forEach((item) => {
              html += item;
            });
            html += "</ul>";
            html +=
              '<button type="button" class="clear-filters">Clear</button>';
            //Add to html
            productReviews.filters.innerHTML = html;
          }
          //Update event handlers after ajax call
          productReviews.handleFilters();
        }
        // } else {
        //   //No reviews found
        // }
        //Update event handlers after ajax call
        productReviews.handleHelpfulRating();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
  updateHelpful: function (reviewId, value, reviewType) {
    // Update display
    let data = {
      action: "updateReviewHelpful",
      page: productReviews.rawPage,
      variantId: productReviews.variantId,
      inventoryType: productReviews.inventoryType,
      reviewId: reviewId,
      value: value,
      reviewType: reviewType,
    };


    fetch(globalObject.url + "ajax/product-catalog.php", {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Accept: "text/plain, application/json, */*",
      },
    })
      .then((response) => response.json())
      .then((response) => {
        // if (response) return;
        let buttonString = value ? `button.${value}` : `button`;

        // console.log(response);
        let help = productReviews.list
            .querySelector("li#review_" + reviewId)
            .querySelector(".helpful-thumbs"),
          button = help.querySelector(buttonString),
          existingCount = button.querySelector(".count");
        //Update count
        existingCount.innerText = parseInt(existingCount.innerText) + 1;
        //Fill in thumb icon
        // button.find('i').removeClass('far').addClass('fas');
        //Disable button
        help.querySelectorAll("button").forEach((btn) => (btn.disabled = true));
        // set cookie
        let getCookies = getCookie("reviews"),
          cookies = {};

        if (getCookies.length) {
          //Get existing cookies
          let existingCookies = JSON.parse(getCookies);
          cookies = existingCookies;
        } else {
          //Create reviews array
          cookies = { helpful: [], notHelpful: [] };
        }
        //Add value to reviews array
        cookies[value].push(reviewId);
        setCookie("reviews", JSON.stringify(cookies), 30);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
};

function brandPageNarrowBy() {
  const isNarrowBy = document.querySelectorAll(
    ".brandContentContainer .narrowBy"
  );

  if (isNarrowBy.length > 0) {
    const unselectedNarrowBys = document.querySelectorAll(
      ".brandContentContainer .narrowBy:not(.selected)"
    );

    unselectedNarrowBys.forEach(function (element) {
      element.addEventListener("click", function (event) {
        const dataId = element.dataset.categories;
        const inputElements = document.querySelectorAll(
          ".categories.filterGroup input"
        );
        const inputElement = Array.from(inputElements).find(
          (input) => input.value === dataId
        );
        const accordion = document.querySelector("#accordion-categories");

        // Add .selected
        element.classList.add("selected");

        // click filter
        inputElement.click();

        // expand accordion
        if (accordion && !accordion.classList.contains("ui-state-active")) {
          accordion.click();
        }

        // Scroll user to the catalog of products
        const catalogContainer = document.querySelector(".catalogContainer");
        const navContainer = document.querySelector(".navContainer");
        window.scrollTo({
          top:
            catalogContainer.getBoundingClientRect().top -
            navContainer.getBoundingClientRect().height,
          behavior: "smooth",
        });
      });
    });
  }
}

function MattressSizes() {
  //Get all our object scoped elements and params
  this.sizeContainer = document.getElementsByClassName("sizeContainer")[0];
  this.variantId =
    document.querySelector("section.variant") !== null
      ? document
          .querySelector("section.variant")
          .getAttribute("id")
          .split("-")[1]
      : null;
  this.isProductPage = document.querySelectorAll(".single-product").length > 0;

  //Get page settings
  const variantSection = document.querySelector(
    "section#variant-" + this.variantId + ".product"
  );
  this.productPage = variantSection
    ? variantSection.getAttribute("data-page")
    : null;
  this.inventoryTypeDir = variantSection
    ? variantSection.getAttribute("data-inventory-type")
    : null;

  this.inventoryType =
    this.inventoryTypeDir == "clearance" || this.inventoryTypeDir == "outlet"
      ? this.inventoryTypeDir
      : "";

  //Cross sells settings
  this.crossSells__container = document.querySelector("section.cross-sells");
  this.crossSells__itemContainer = this.crossSells__container
    ? this.crossSells__container.querySelectorAll(".cross-sells__item")
    : [];

  this.crossSells__variantId = this.variantId;
  this.crossSells__inventoryTypeDir = document
    .querySelector(
      "section.cross-sells__item#variant-" +
        this.crossSells__variantId +
        ".product"
    )
    ?.getAttribute("data-inventory-type");

  this.crossSells__inventoryType =
    this.crossSells__inventoryTypeDir === "clearance" ||
    this.crossSells__inventoryTypeDir === "outlet"
      ? this.crossSells__inventoryTypeDir
      : "";

  this.init = function () {
    if (!this.sizeContainer) return;
    this.handleEvents();
  };

  this.handleEvents = function () {
    document.querySelectorAll(".sizeContainer .sizeOption").forEach(element => {
      element.addEventListener("mouseenter", e => {
        const attributeTitle = e.target.dataset.option;
        e.target.closest(".sizeContainer").querySelector(".selectedAttribute").innerHTML = attributeTitle;
      });
      element.addEventListener("mouseleave", e => {
        let attributeTitle = '';
        const selectedAttribute = e.target.closest(".sizeContainer").querySelector(".selected");
        if (selectedAttribute){
          attributeTitle = selectedAttribute.dataset.option;
        }
        e.target.closest(".sizeContainer").querySelector(".selectedAttribute").innerHTML = attributeTitle;
      });
    });
  };

}
class MyStoreSelector {
  constructor() {}
  init() {
    this.handleEvents();
  }
  handleEvents() {
    let self = this;
    const variant = document.querySelector(".variant");
    const variantId = variant ? variant.id.split("-")[1] : null;

    //Get user's location
    if (getCookie("loc") === false) {
      this.setUserLocation();
    }

    //Show on display stores
    document
      .querySelector(".showOnDisplayStores")
      ?.addEventListener("click", function (e) {
        e.preventDefault();
        self.showOnDisplayStores(variantId);
      });

    //Change my store
    document.querySelectorAll(".changeStore")?.forEach((item) => {
      item.addEventListener("click", function (e) {
        e.preventDefault();
        self.displayChangeStoreSlidePanel(e);
      });
    });

    //Change store pickup
    document
      .querySelector(".changeStorePickup")
      ?.addEventListener("click", function (e) {
        e.preventDefault();
        self.displayChangeStorePickupSlidePanel();
      });

    //Save as my store button on locations pages
    document.querySelectorAll(".location-item .storeLinks li.saveStore a")?.forEach((item) =>
      item.addEventListener("click", function (e) {
        e.preventDefault();
        //Set cookie & hide store selection overlay
        let storeId = e.target
          .closest(".location-item")
          .children[1].id.split("_")[1];
        setCookie("locStoreId", storeId, 30);
        window.location.reload();
      })
    );

    // Save as my store button on location page
    document.querySelector(".page-location .storeLinks li.saveStore a")?.addEventListener('click', (e) => {
      e.preventDefault();
      //Set cookie & hide store selection overlay
      let storeId = e.target
        .closest(".locationInfoBox")?.id?.split("_")[1];
      if(storeId) {
        setCookie("locStoreId", storeId, 30);
        window.location.reload();
      }
    })

    //Header geolocator dropdown
    this.handleStoreDropdownClick();
  }

  handleStoreDropdownClick() {
    document
      .querySelector("header .showStoreInfo")
      ?.addEventListener("click", function (e) {
        e.target
          .closest("header")
          .querySelector(".storeLocationDropdown").style.display = "block";
      });
    document
      .querySelector(".storeLocationDropdown .close")
      ?.addEventListener("click", function (e) {
        e.target.closest(".storeLocationDropdown").style.display = "none";
      });
  }

  setUserLocation() {
    const data = { action: "getLocationByIP" };

    fetch(globalObject.url + "ajax/locator.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((responseData) => {
        const userLocation =
          responseData.latitude && responseData.longitude
            ? `${responseData.latitude},${responseData.longitude}`
            : "";
        setCookie("loc", userLocation, 30);
        this.displayClosestStore();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  displayClosestStore() {
    let self = this;
    let userLocation = getCookie("loc");
    if (!getCookie("locStoreId") && userLocation) {
      //Get closest store to user
      fetch(globalObject.url + "ajax/locator.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          action: "getClosestStore",
          userLocation: userLocation,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.id && !getCookie("locStoreId")) {
            let loc = data;
            try { getSVGIcon("map-marker", "svg-white", ".map-marker"); } catch (e) {}
            try { getSVGIcon("chevron-down", "svg-white", ".chevron-down"); } catch (e) {}
            try { getSVGIcon("close", "svg-white", ".store-dropdown-close"); } catch (e) {}
            //Set store id
            setCookie("locStoreId", data.id, 30);
            //Also change pickup location
            const pickupId = data.inStorePickupId;
            if (pickupId != 0) {
              setCookie("pickupStoreId", pickupId, 30);
            }
            //Display in header
            let html = `
              <span class="showStoreInfo" title="Store details">
                <i class="map-marker"></i>
                ${loc.city}, ${loc.state}
                <i class="chevron-down"></i>
              </span>
              <div class="storeLocationDropdown">
                <div class="store-dropdown-close">
                  <i class="close"></i>
                </div>
                <h5>${loc.title || `${loc.city}, ${loc.state}`}</h5>
                <p>
                  ${loc.address ? loc.address : ""}
                  ${loc.address2 ? " " + loc.address2 : ""}
                  <br>
                  ${loc.city}, ${loc.state} ${loc.zip ? loc.zip : ""}
                  <br>
                  <a href="tel:${loc.phone}">${formatPhone(loc.phone)}</a>
                </p>
                <p><strong><a href="${globalObject.url}locations/${loc.page}">Store details</a></strong></p>
                <button class="changeStore" title="Change Your Store">Change Your Store</button>
              </div>
            `;
            const storeLocationEl = document.querySelector(".storeLocation.top-bar-element");
            if (storeLocationEl) {
              storeLocationEl.innerHTML = html;

              //Change my store
              document.querySelectorAll(".changeStore")?.forEach((item) => {
                item.addEventListener("click", function (e) {
                  e.preventDefault();
                  self.displayChangeStoreSlidePanel(e);
                });
              });

              // Show dropdown when clicking store info
              document
                .querySelector("header .showStoreInfo")
                ?.addEventListener("click", function (e) {
                  e.target
                    .closest("header")
                    .querySelector(".storeLocationDropdown").style.display = "block";
                });

              // Hide dropdown when clicking close button
              document
                .querySelector(".storeLocationDropdown .store-dropdown-close")
                ?.addEventListener("click", function (e) {
                  e.target.closest(".storeLocationDropdown").style.display = "none";
                });
            }
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }

  showOnDisplayStores(variantId) {
    //Display on display stores in slide panel
    fetch(globalObject.url + "ajax/locator.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        action: "showOnDisplayStores",
        variantId: variantId,
      }),
    })
      .then((response) => response.text())
      .then((data) => {
        //If panel isn't already on page, append it to body
        if (document.querySelector(".showOnDisplayStoresSlidePanel") === null) {
          document.querySelector("body").insertAdjacentHTML("beforeend", data);
        }
        //Wait a lil and open the side panel
        setTimeout(function () {
          //Show panel
          var panelId = "#showOnDisplayStoresSlidePanel";
          // var panel = $(panelId);
          toggleSlidePanel(panelId, "open");
        }, 300);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  displayChangeStoreSlidePanel(event) {
    let currentStore = getCookie("locStoreId");

    const currentElement = event.target;

    const catalogItem = currentElement.closest(".catalogItem");
    const variantElement = currentElement.closest(".variant");

    // Get variant id if available
    let variantId = null;
    if (catalogItem) {
      variantId = catalogItem.id.split("_")[1];
    } else if (variantElement) {
      variantId = variantElement.id.split("-")[1];
    } else {
      variantId = 0;
    }


    // Get panel selector
    let panelId = "#changeStoreSlidePanel";

    fetch(globalObject.url + "ajax/locator.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        action: "displayChangeStoreSlidePanel",
        currentStore: currentStore,
        variantId: variantId,
      }),
    })
      .then((response) => response.text())
      .then((data) => {
        // If panel isn't already on page, append it to body
        if (document.querySelector(panelId) === null) {
          document.querySelector("body").insertAdjacentHTML("beforeend", data);
        }

        // Wait a bit and open the side panel
        setTimeout(function () {
          // Show panel
          toggleSlidePanel(panelId, "open");

          // Watch for store change
          document
            .querySelectorAll(panelId + " .storeSelect button")
            .forEach((el) => {
              el.addEventListener("click", function () {
                // Set cookie & hide store selection overlay
                setCookie("locStoreId", this.dataset.storeid, 30);

                // Also change pickup location
                const pickupId = this.dataset.storepickupid;
                if (pickupId != 0) {
                  setCookie("pickupStoreId", pickupId, 30);
                }

                toggleSlidePanel(panelId, "close");
                window.location.reload();
              });
            });
        }, 300);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  displayChangeStorePickupSlidePanel() {
    //Get user's current store
    let currentStore = getCookie("pickupStoreId");
    //Get panel selector
    let panelId = "#changeStoreSlidePanel.storePickup";

    fetch(globalObject.url + "ajax/locator.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        action: "displayChangeStorePickupSlidePanel",
        currentStore: currentStore,
      }),
    })
      .then((response) => response.text())
      .then((data) => {
        //If panel isn't already on page, append it to body
        if (document.querySelector(panelId) === null) {
          document.querySelector("body").insertAdjacentHTML("beforeend", data);
        }
        //Wait a lil and open the side panel
        setTimeout(function () {
          //Show panel
          // let panel = document.querySelector(panelId);
          toggleSlidePanel(panelId, "open");
          //Watch for store change
          document
            .querySelectorAll(panelId + " .storeSelect button")
            .forEach((el) => {
              el.addEventListener("click", function () {
                //Hide store selection overlay
                setCookie("pickupStoreId", this.dataset.storeid, 30);
                //Also change store location
                const storeId = this.dataset.storeid;
                if (storeId) {
                  setCookie("locStoreId", storeId, 30);
                }
                toggleSlidePanel(panelId, "close");
                window.location.reload();
              });
            });
        }, 300);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

// Refactored with Alpine
// function CrossSells() {
//   this.container = $("section.cross-sells");
//   this.selectAllCheckbox = this.container.find(
//     "input[type=checkbox][name=selectAll]"
//   );
//   this.totalPriceContainer = this.container.find(".cross-sells__total-price");

//   this.init = function () {
//     this.handleEvents();
//   };

//   this.handleEvents = function () {
//     const self = this;

//     //Toggle click entire cross sells container to expand
//     this.container.click(function (e) {
//       if (!$(this).hasClass("cross-sells--expanded")) {
//         //Check if label or input isn't already being triggered
//         if (
//           e.target.tagName.toLowerCase() !== "label" &&
//           e.target.tagName.toLowerCase() !== "input" &&
//           e.target.tagName.toLowerCase() !== "svg" &&
//           e.target.tagName.toLowerCase() !== "span" &&
//           e.target.parentNode.tagName.toLowerCase() !== "label"
//         ) {
//           self.selectAllCheckbox.closest("label").trigger("click");
//         }
//       }
//     });

//     //Change checkbox to select all cross sells
//     this.selectAllCheckbox.change(function (e) {
//       const icon = $(this).closest("label").find(".svg-icon");
//       if ($(this).is(":checked")) {
//         self.expand();
//         getSVGIcon("check-square", "", icon, true);
//       } else {
//         self.collapse();
//         getSVGIcon("square-o", "", icon, true);
//       }
//       //Select/deselect all checkboxes
//       self.container
//         .find(
//           "label.ecommerce-enabled input[type=checkbox][name^=addToCart_crossSell]"
//         )
//         .each(function () {
//           $(this).closest("label").trigger("click");
//         });
//     });

//     //Change cross sell item checkbox to indicate not all items are checked on select all checkbox
//     this.container
//       .find("input[type=checkbox][name^=addToCart_crossSell]")
//       .click(function () {
//         const item = $(this).closest(".cross-sells__item");
//         const icon = self.selectAllCheckbox.closest("label").find(".svg-icon");

//         //Check if all eligible items are checked
//         const eligibleCount = self.container.find(
//           "label.ecommerce-enabled input[type=checkbox][name^=addToCart_crossSell]"
//         ).length;
//         const checkedCount =
//           self.container.find(
//             "label.ecommerce-enabled input[type=checkbox][name^=addToCart_crossSell]:checked"
//           ).length + 1; //+1 to account for current item
//         //Update icons
//         if (checkedCount < eligibleCount) {
//           getSVGIcon("minus-square", "", icon, true);
//         } else {
//           getSVGIcon("check-square", "", icon, true);
//         }

//         //Update total price
//         let totalPrice = parseFloat(
//           self.totalPriceContainer.find(".price").text().replace(/\$|,/gim, "")
//         );
//         const itemPrice = parseFloat(
//           item
//             .find(".price")
//             .html()
//             .replace(/<p.*<\/p>|<span.*<\/span>|\$|,/gim, "")
//         );
//         if ($(this).is(":checked")) {
//           //Checkbox changed to checked, add price
//           totalPrice = totalPrice + itemPrice;
//         } else {
//           //Checkbox changed to not checked, subtract price
//           totalPrice = totalPrice - itemPrice;
//         }
//         //Replace total price
//         self.totalPriceContainer
//           .find(".price")
//           .html(formatPrice.format(totalPrice));
//         self.totalPriceContainer.find(".price-label").html("Total Price"); //Replace label
//       });
//   };

//   this.collapse = function () {
//     //Collapse container
//     if (!this.container.hasClass("cross-sells--single-count")) {
//       //Remove expanded class
//       this.container.removeClass("cross-sells--expanded");
//       //Show show all "link"
//       this.container.find(".cross-sells__header .show-all").show();
//     }
//   };

//   this.expand = function () {
//     //Expand container
//     this.container.addClass("cross-sells--expanded");
//     //Hide show all "link"
//     this.container.find(".cross-sells__header .show-all").hide();
//   };
// }

class DesignProjectForm {
  constructor() {
    this.container = document.querySelector(".design-studio-container");
    this.nextButton = this.container?.querySelector("button.next") ?? null;
    this.previousButton =
      this.container?.querySelector("button.previous") ?? null;
    this.submitButton =
      this.container?.querySelector("button.submit-form") ?? null;
    this.formContainer =
      this.container?.querySelector(".design-project-form") ?? null;
    this.form = this.formContainer?.querySelector("form") ?? null;
    this.resultsContainer =
      this.container?.querySelector(".design-project-form-results") ?? null;
  }

  init() {
    if (!this.container) return;

    this.onPageLoad();
    this.handleEvents();
  }

  onPageLoad() {
    this.clearFields();

    // Check if form contact form is already completed or skipped
    if (getCookie("designProjectForm_completed") == 1) {
      this.showResults();
    } else {
      this.resultsContainer.style.display = "none";
    }
  }

  handleEvents() {
    this.handleFormFields();

    // Show next question
    if (this.nextButton) {
      this.nextButton.addEventListener("click", () => this.showNextQuestion());
    }

    // Show previous question
    if (this.previousButton) {
      this.previousButton.addEventListener("click", () =>
        this.showPreviousQuestion()
      );
    }

    // Handle submit
    if (this.submitButton) {
      this.handleSubmit();
    }

    // Show form
    if (this.resultsContainer) {
      this.resultsContainer.querySelectorAll("a.show-form").forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          setCookie("designProjectForm_completed", 0, 1);
          this.showForm();
        });
      });
    }

    // Handle file upload
    if (this.form) {
      this.handleFileUpload();
    }
  }

  handleFormFields() {
    const formFields = this.container.querySelectorAll(
      ".design-project-form__options input, .design-project-form__options textarea"
    );
    if (formFields.length > 0) {
      formFields.forEach((field) => {
        field.addEventListener("change", () => {
          this.toggleButtons();
        });
        field.addEventListener("input", () => {
          this.toggleButtons();
        });
        field.addEventListener("blur", () => {
          setTimeout(() => {
            this.toggleButtons();
          }, 200);
        });
      });
    }
  }

  handleSubmit() {
    this.submitButton.addEventListener("click", () => {
      const existingBanne = this.container.querySelector(
        ".alertBanner.submission-result"
      );
      if (existingBanne) {
        existingBanne.remove();
      }

      // Wait for form to submit
      let formSubmit = setInterval(() => {
        const alertBanner = this.formContainer.querySelectorAll(
          ".alertBanner.submission-result"
        );
        if (alertBanner.length > 0) {
          clearInterval(formSubmit);

          // Remove "already completed" text for now
          const resultsParagraphs = this.resultsContainer.querySelectorAll("p");
          resultsParagraphs.forEach((paragraph) => paragraph.remove());

          // Check for errors
          const hasSuccess = this.formContainer.querySelectorAll(
            ".alertBanner.submission-result.success"
          );
          if (hasSuccess.length > 0) {
            // Indicate user has completed design project form
            setCookie("designProjectForm_completed", 1, 1);

            // Show form results
            this.showResults();
          }
        }
      }, 100);
    });
  }

  handleFileUpload() {
    const fileInput = this.form.querySelector("input[type=file]");
    if (fileInput) {
      fileInput.addEventListener("change", function () {
        let files = [];
        for (let i = 0; i < this.files.length; ++i) {
          const file = this.files[i];
          files.push(file);
        }

        // Display on page
        const filesPreview = document.querySelector(".files-preview");
        if (filesPreview) {
          filesPreview.innerHTML = files
            .map(function (file) {
              return `<div class="file">${file.name}</div>`;
            })
            .join("");
        }
      });
    }
  }

  clearFields() {
    // Clear input checked values
    this.container
      .querySelectorAll("input[type=radio], input[type=checkbox]")
      .forEach((input) => {
        input.checked = false;
      });

    // Clear input values
    this.container
      .querySelectorAll("input[type=text], textarea")
      .forEach((input) => {
        input.value = "";
      });

    // Uncheck questions
    this.container
      .querySelectorAll(".design-project-form__question:not(:first-child)")
      .forEach((question) => {
        question.classList.remove("active");
      });
  }

  isFirstQuestion() {
    return this.container
      .querySelector(".design-project-form__question:first-child")
      .classList.contains("active");
  }

  isLastQuestion() {
    return this.container
      .querySelector(".design-project-form__question:last-child")
      .classList.contains("active");
  }

  isCurrentQuestionRequired() {
    return (
      this.container
        .querySelector(".design-project-form__question.active")
        .querySelectorAll("input:required").length > 0
    );
  }

  isCurrentQuestionAnswered() {
    const currentQuestion = this.container.querySelector(
      ".design-project-form__question.active"
    );
    const requiredQuestions =
      currentQuestion.querySelectorAll("input:required");
    const hasValidationErrors =
      currentQuestion.querySelectorAll(".error").length > 0;

    if (requiredQuestions.length > 0 && !hasValidationErrors) {
      let requiredQuestionsAnswered = 0;
      requiredQuestions.forEach((question) => {
        if (question.value == "") {
          return false;
        } else {
          requiredQuestionsAnswered++;
        }
      });

      return requiredQuestionsAnswered === requiredQuestions.length;
    }

    return hasValidationErrors ? false : true;
  }

  toggleButtons() {
    if (this.isFirstQuestion()) {
      this.previousButton.disabled = true;
      this.nextButton.disabled = !this.isCurrentQuestionAnswered();
      this.submitButton.disabled = true;
    } else if (this.isLastQuestion()) {
      this.previousButton.disabled = false;
      this.nextButton.disabled = true;
      this.submitButton.disabled = !this.isCurrentQuestionAnswered();
    } else {
      this.previousButton.disabled = false;
      this.nextButton.disabled = !this.isCurrentQuestionAnswered();
      this.submitButton.disabled = true;
    }

    this.nextButton.style.display = this.isLastQuestion() ? "none" : "block";
    this.submitButton.style.display = this.isLastQuestion() ? "block" : "none";
  }

  showNextQuestion() {
    const currentQuestion = this.container.querySelector(
      ".design-project-form__question.active"
    );
    const nextQuestion = currentQuestion.nextElementSibling;

    currentQuestion.classList.remove("active");
    nextQuestion.classList.add("active");

    this.toggleButtons();
  }

  showPreviousQuestion() {
    const currentQuestion = this.container.querySelector(
      ".design-project-form__question.active"
    );
    const previousQuestion = currentQuestion.previousElementSibling;

    currentQuestion.classList.remove("active");
    previousQuestion.classList.add("active");

    this.toggleButtons();
  }

  showForm() {
    this.formContainer.style.display = "block";
    this.resultsContainer.style.display = "none";
  }

  showResults() {
    this.formContainer.style.display = "none";
    this.resultsContainer.style.display = "block";

    const alertBanner = this.form.querySelector(
      ".alertBanner.submission-result"
    );
    if (alertBanner) {
      alertBanner.remove();
      const clonedBanner = alertBanner.cloneNode(true);
      this.resultsContainer.insertBefore(
        clonedBanner,
        this.resultsContainer.firstChild
      );
    }
  }
}

class StyleQuiz {
  constructor() {
    this.container = document.querySelector(".style-quiz-container");
    this.nextButton = this.container?.querySelector("button.next") ?? null;
    this.previousButton =
      this.container?.querySelector("button.previous") ?? null;
    this.submitButton =
      this.container?.querySelector("button.submit-quiz") ?? null;
    this.contactContainer =
      this.container?.querySelector(".contact-form") ?? null;
    this.contactForm = this.contactContainer?.querySelector("form") ?? null;
    this.resultsContainer =
      this.container?.querySelector(".style-results") ?? null;
  }

  init() {
    if (!this.container) return;

    this.onPageLoad();
    this.handleEvents();
  }

  handleEvents() {
    const answers = this.container.querySelectorAll(
      ".style-quiz__answers input"
    );
    if (answers.length > 0) {
      answers.forEach((answer) => {
        answer.addEventListener("change", () => {
          this.activateButtons();
        });
      });
    }

    // Show next question
    if (this.nextButton) {
      this.nextButton.addEventListener("click", () =>
        this.activateNextQuestion()
      );
    }

    // Show previous question
    if (this.previousButton) {
      this.previousButton.addEventListener("click", () =>
        this.activatePreviousQuestion()
      );
    }

    // Handle submit
    if (this.submitButton) {
      this.submitButton.addEventListener("click", () => {
        setCookie("styleQuiz_completed", 1, 1);
      });
    }

    if (this.contactContainer) {
      const skipButtons =
        this.contactContainer.querySelectorAll(".skip-this-step");
      skipButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          setCookie("styleQuiz_contactSkipped", 1, 1);
          this.showResults();
        });
      });
    }

    if (this.contactForm) {
      const contactButton = this.contactForm.querySelector(".contact-button");
      contactButton.addEventListener("click", () => {
        let formSubmit = setInterval(() => {
          if (
            this.contactContainer.querySelector(
              ".alertBanner.submission-result"
            )
          ) {
            clearInterval(formSubmit);
            setCookie("styleQuiz_contactCompleted", 1, 1);
            this.showResults();
            this.mergeContactWithQuiz();
          }
        }, 100);
      });
    }
  }

  onPageLoad() {
    // Clear quiz field
    this.clearFields();

    // Check if styles have been selected
    const selectedStyles = getUrlParameter("styles");
    if (selectedStyles) {
      setCookie("favorite_styles", selectedStyles, 30);
    }
  }

  isFirstQuestion() {
    const firstQuestion = this.container.querySelector(
      ".style-quiz__question:first-child"
    );
    return firstQuestion.classList.contains("active");
  }

  isLastQuestion() {
    const lastQuestion = this.container.querySelector(
      ".style-quiz__question:last-child"
    );
    return lastQuestion.classList.contains("active");
  }

  clearFields() {
    // Clear input values
    const inputs = this.container.querySelectorAll("input");
    inputs.forEach((input) => {
      input.checked = false;
    });

    // Uncheck questions
    const questions = this.container.querySelectorAll(
      ".style-quiz__question:not(:first-child)"
    );
    questions.forEach((question) => {
      question.classList.remove("active");
    });
  }

  activateButtons() {
    const isFirstQuestion = this.isFirstQuestion();
    const isLastQuestion = this.isLastQuestion();

    if (isFirstQuestion) {
      this.previousButton.disabled = true;
      this.nextButton.disabled = false;
      this.submitButton.disabled = true;
    } else if (isLastQuestion) {
      this.previousButton.disabled = false;
      this.nextButton.disabled = true;
      this.submitButton.disabled = false;
    } else {
      this.previousButton.disabled = false;
      this.nextButton.disabled = false;
      this.submitButton.disabled = true;
    }
  }

  activateNextQuestion() {
    const currentQuestion = this.container.querySelector(
      ".style-quiz__question.active"
    );
    const nextQuestion = currentQuestion.nextElementSibling;

    currentQuestion.classList.remove("active");
    nextQuestion.classList.add("active");

    this.showQuestion(nextQuestion);
  }

  activatePreviousQuestion() {
    const currentQuestion = this.container.querySelector(
      ".style-quiz__question.active"
    );
    const previousQuestion = currentQuestion.previousElementSibling;

    currentQuestion.classList.remove("active");
    previousQuestion.classList.add("active");

    this.showQuestion(previousQuestion);
  }

  showQuestion(question) {
    const isAnswered = question.querySelector("input[type='radio']:checked");

    if (isAnswered && !this.isLastQuestion()) {
      this.nextButton.disabled = false;
    } else {
      this.nextButton.disabled = true;
    }

    if (this.isFirstQuestion()) {
      this.previousButton.disabled = true;
    } else {
      this.previousButton.disabled = false;
    }

    this.toggleSubmitButton();
  }

  toggleSubmitButton() {
    if (this.isLastQuestion()) {
      this.nextButton.style.display = "none";
      this.submitButton.style.display = "block";
    } else {
      this.nextButton.style.display = "block";
      this.submitButton.style.display = "none";
    }
  }

  showResults() {
    this.contactContainer.style.display = "none";
    this.resultsContainer.style.display = "block";
  }

  mergeContactWithQuiz() {
    // Show loading spinner
    showLoadingOverlay();

    let formData = new FormData(this.contactForm);
    let serializedData = new URLSearchParams(formData).toString();

    fetch(
      globalObject.url + "ajax/style-quiz.php?action=mergeContactWithQuiz",
      {
        method: "POST",
        body: serializedData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    )
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        hideLoadingOverlay();
      });
  }
}

class SearchSuggester {
  constructor(selector) {
    this.formElement = document.querySelector(selector);
    this.suggestionsElement = this.formElement?.nextElementSibling;
    this.searchInput = this.formElement?.querySelector(".searchbox-input");
    this.closeSuggestions =
      this.suggestionsElement?.querySelector(".closeSuggestions");
    this.searchLength = 0;
    this.ajaxRequest = null;

    this.categorySuggestions = [];
    this.productSuggestions = [];
    this.brandSuggestions = [];
  }

  init() {
    if (!this.formElement) return;
    this.handleEvents();
  }

  handleEvents() {
    this.searchInput.addEventListener("keyup", () => {
      if (this.searchInput.value.length > 0) {
        this.suggest();
        this.suggestionsElement.style.display = "block";
      } else {
        this.suggestionsElement.style.display = "none";
      }
    });

    this.searchInput.addEventListener("focus", () => {
      const query = this.searchInput.value;
      if (this.searchLength == 0 && query.length == 0) {
        this.suggestionsElement.style.display = "none";
      } else if (query.length > 0) {
        this.suggestionsElement.style.display = "block";
      }
    });

    document.body.addEventListener("click", (e) => {
      try {
        if (
          e.target !== this.searchInput &&
          e.target !== this.suggestionsElement &&
          !e.target.closest(".searchSuggestions")
        ) {
          this.suggestionsElement.style.display = "none";
        }
      } catch (error) {
        console.error("Error:", error);
      }
    });

    this.closeSuggestions.addEventListener("click", () => {
      this.suggestionsElement.style.display = "none";
    });

    this.suggestionsElement.addEventListener("click", (e) => {
      const query = e.target.textContent;
      const field = e.target.closest("ul")?.dataset.field;
      if (!field) return;

      const data = new URLSearchParams({ q: query, f: field });
      fetch(globalObject.url + "ajax/search.php?action=suggestionUrl", {
        method: "POST",
        body: data,
      })
        .then((response) => response.text())
        .then((response) => {
          if (response.length > 0) {
            window.location.href = response;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    });
  }

  suggest() {
    const query = this.searchInput.value;
    let getSuggestions = false;
    if (query.length != this.searchLength) {
      this.searchLength = query.length;
      if (query.length > 0) {
        this.suggestionsElement.querySelector(
          'ul[data-field="searchQuery"]'
        ).innerHTML = `<li><b>${query}</b></li>`;
        getSuggestions = true;
      }
    }

    if (getSuggestions) {
      fetch(globalObject.url + "ajax/search.php?action=suggest", {
        method: "POST",
        body: new URLSearchParams({ q: query }),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response && response.suggest) {
            this.categorySuggestions = [
              ...this.getResultsArray(response.suggest.categorySuggest),
            ];
            this.productSuggestions = [
              ...this.getResultsArray(response.suggest.productSuggest),
            ];
            this.brandSuggestions = [
              ...this.getResultsArray(response.suggest.brandTitle),
            ];

            this.showCategorySuggestions();
            this.showProductSuggestions();
            this.showBrandSuggestions();
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  }

  showCategorySuggestions() {
    const categoryUl = this.suggestionsElement.querySelector(
      'ul[data-field="categorySuggest"]'
    );
    if (this.categorySuggestions.length > 0) {
      categoryUl.innerHTML = this.categorySuggestions
        .map((suggestion) => `<li>${suggestion}</li>`)
        .join("");
      categoryUl.style.display = "block";
    } else {
      categoryUl.style.display = "none";
    }
  }

  showProductSuggestions() {
    const productUl = this.suggestionsElement.querySelector(
      'ul[data-field="productSuggest"]'
    );
    if (this.productSuggestions.length > 0) {
      productUl.innerHTML = this.productSuggestions
        .map((suggestion) => `<li>${suggestion}</li>`)
        .join("");
      productUl.style.display = "block";
    } else {
      productUl.style.display = "none";
    }
  }

  showBrandSuggestions() {
    const brandUl = this.suggestionsElement.querySelector(
      'ul[data-field="brandTitle"]'
    );
    if (this.brandSuggestions.length > 0) {
      brandUl.innerHTML = this.brandSuggestions
        .map((suggestion) => `<li>${suggestion}</li>`)
        .join("");
      brandUl.style.display = "block";
    } else {
      brandUl.style.display = "none";
    }
  }

  getResultsArray(data) {
    const resultsData = Object.values(data)[0];
    let result = [];
    if (resultsData && resultsData.numFound > 0) {
      result = resultsData.suggestions.map((result) => {
        let div = document.createElement("div");
        div.innerHTML = result.term.replace(/<\/?b>/g, "");
        return div.textContent;
      });
    }

    return result;
  }
}
class ZipCodeChanger {
  constructor() {
    this.form = document.querySelector("form.setZipCodeForm");
  }
  init() {
    if (!this.form) return;

    this.handleEvents();
  }
  handleEvents() {
    this.form.addEventListener("submit", (e) => {
      e.preventDefault();
      const button = this.form.querySelector("button");
      const zipCode = this.form.querySelector("input[name=zipCode]").value;
      const validationErrors = this.form.querySelectorAll(".validationError");

      if (zipCode != getCookie("zip")) {
        validationErrors.forEach((error) => (error.display = "none"));
        updateUserLocation(zipCode, button, true);
      } else {
        validationErrors.forEach((error) => {
          if (error.classList.contains("sameZip")) {
            error.style.display = "block";
          }
        });
      }
    });
  }
}

function updateUserLocation(zipCode, submitButton = "", reload = false) {
  // Update Zip Code
  fetch(globalObject.url + "ajax/locator.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: toUrlEncodedFormData({
      action: "updateZipCode",
      zip: zipCode,
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      // Reset zip & location values
      setCookie("zip", zipCode, 30);
      let userLocation = `${data.lat},${data.lng}`;
      setCookie("loc", userLocation, 30);

      // Indicate loading (if submitButton is provided)
      // TODO: Implement loadingButton
      // if (submitButton) {
      //   loadingButton("loading", submitButton);
      // }

      // Update closest store
      return fetch(globalObject.url + "ajax/locator.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: toUrlEncodedFormData({
          action: "getClosestStore",
          userLocation: userLocation,
        }),
      });
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.id) {
        // Reset pickup location id
        setCookie("locStoreId", data.id, 30);

        // Also change pickup location
        const pickupId = data.inStorePickupId;
        if (pickupId != 0) {
          setCookie("pickupStoreId", pickupId, 30);
        }

        // Reload window (if reload is true)
        if (reload) {
          window.location.reload();
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Helper function to convert an object to URL-encoded form data
function toUrlEncodedFormData(obj) {
  return Object.keys(obj)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
    .join("&");
}

//LIVE CHAT  moved to vanilla js
function LHN_button_onLoad() {
  if (bLHNOnline == 0) {
    //All operators are offline
    document.querySelector(".liveChat").classList.add("hide");
  } else {
    //There are operators online
    document.querySelector(".liveChat").classList.remove("hide");
  }
}

// fixed nav onscroll. Mobile and Desktop
//$(window).resize(checksize);
// TODO: Remove jQuery (this will be replaced by Alpine with the new nav)
function checksize() {
  // resetNav();
  //Navigation
  var windowsize = window.innerWidth;
  var specialPage = $("body.special");
  if (windowsize >= 1024) {
    //Desktop
    // var fixmeTop = $(".mainNav").offset().top;
    // $(window).scroll(function () {
    //     var currentScroll = $(window).scrollTop();
    //     if (currentScroll >= fixmeTop) {
    //         $(".mobileNavSlider .mainNav").css({
    //             position: "fixed",
    //             top: "0",
    //             left: "0",
    //             width: "100%",
    //             top: "-20px",
    //         });
    //     } else {
    //         $(".mobileNavSlider .mainNav").css({
    //             position: "relative",
    //             top: "0px",
    //             width: "100%",
    //         });
    //     }
    // });
    //Display navContainer after screen resize
    $(".navContainer")
      .show()
      .css({ width: "100%", marginLeft: 0 })
      .addClass("desktop-view");
    $(".mobileNavSlider").css({ marginLeft: 0 });
    $(".dropdown, .mainNavLink").show().css({ marginLeft: 0 });
    $(".mainNavLink").parent("li").show();
    //Check which way navigation should drop
    let timer;
    let delay = 451;
    // I think the nav in general could be done better...
    $(".mainNav > ul > li").hover(
      function () {
        //Add "hovering" class to li
        $(this).addClass("hovering");
        //Darken background
        let thisDropdown = $(".dropdown:first", this);
        if (thisDropdown.length > 0) {
          timer = setTimeout(function () {
            $("main, footer").addClass("darken"); // I think this could be gone...
          }, delay);
          //if child # is less than or equal to half way across main nav
          var posCheck =
            $(".mainNav > ul > li").index($(this)) + 1 <=
            $(".mainNav > ul > li").length / 2;
          if (!posCheck) {
            $(this).addClass("edge");
          } /* else {
					$(this).removeClass('edge');
				} */
        }
      },
      function () {
        clearTimeout(timer);
        $(this).removeClass("hovering");
        $("main, footer").removeClass("darken");
      }
    );
  } else {
    //Mobile
    // var fixmeTop = $(".mobile-nav").offset().top;
    // if ($(".navContainer").hasClass("desktop-view")) {
    //     $(".navContainer")
    //         .css({ width: "0%", marginLeft: 0 })
    //         .hide()
    //         .removeClass("desktop-view");
    // }
    // $(window).scroll(function () {
    //     var currentScroll = $(window).scrollTop();
    // if (currentScroll >= fixmeTop) {
    // $(".mobile-nav").css({
    //     position: "fixed",
    //     top: "0",
    //     left: "0",
    //     width: "100%",
    // });
    // $(".mobileSearch").css({
    //     position: "fixed",
    //     top: "42px",
    //     zindex: "999",
    // });
    // } else {
    // $(".mobile-nav").css({
    //     position: "relative",
    //     width: "100%",
    // });
    // $(".mobileSearch").css({
    //     position: "relative",
    //     top: "0px",
    // });
    // }
    // });
    $(".mainNavLink").click(function (e) {
      if ($(this).next(".dropdown").length) {
        e.preventDefault();
        $(".mainNavLink").animate({
          marginLeft: "-90vw",
          width: "toggle",
        });
        $(".mainNavLink").not($(this)).parent("li").hide();
        // $(this).addClass('active');
        $(this).next(".dropdown").show();
        $(".backShopNavLevel1")
          .addClass("backShopNavLevel2")
          .removeClass("backShopNavLevel1");
      }
    });
  }

  // CondensedNav Animation
  if ($(".condensedNav").length && window.outerWidth < 991) {
    $("#helpful-info").on("click", () => {
      $(".subNav").animate({ marginLeft: "-100%" });
      $("#helpful-info").children("nav").animate({ left: "0%" });
      $(".slide-shop-buttons").animate({ marginLeft: "-90vw" });
    });
    $("#hot-tubs").on("click", () => {
      $(".subNav").animate({ marginLeft: "-100%" });
      $("#hot-tubs").children("nav").animate({ left: "0%" });
      $(".slide-shop-buttons").animate({ marginLeft: "-90vw" });
    });
    $("#service").on("click", () => {
      $(".subNav").animate({ marginLeft: "-100%" });
      $("#service").children("nav").animate({ left: "0%" });
      $(".slide-shop-buttons").animate({ marginLeft: "-90vw" });
    });
    $("#kitchen-cabinets").on("click", function () {
      $(".subNav").animate({
        marginLeft: "-100%",
      });
      $("#kitchen-cabinets").children("nav").animate({
        left: "0%",
      });
      $(".slide-shop-buttons").animate({ marginLeft: "-90vw" });
    });
    $("#design-center").on("click", () => {
      console.log("design click");
      $(".subNav").animate({ marginLeft: "-100%" });
      $("#design-center").children("nav").animate({ left: "0%" });
      $(".slide-shop-buttons").animate({ marginLeft: "-90vw" });
    });
    // $(".backShopNav").on('click', function (e) {
    // 	$('.subNav').animate({
    // 		marginLeft: '0%'
    // 	});
    // 	$(this).parent().animate({
    // 		left: '100%'
    // 	});
    // 	e.stopPropagation();
    // });
  } else if ($(".condensedNav").length && window.outerWidth >= 991) {
    $(".subNav li.has-subnav").off();
    $(".subNav").css({ "margin-left": 0 });
    $(".navContainer").css({ width: "100%" }).show();
  }

  if (windowsize >= 1024 && $("body").not(".special")) {
    //If window is greater than break-nav, toggle filters
    if ($(".filter-aside").is(":hidden")) {
      toggleFilters();
    } else if (
      $(".filter-aside").is(":visible") ||
      $(".filter-aside").length == 0
    ) {
      //Adjust body classes
      $("body").removeClass("slidePanel-showing").removeClass("darken");
      //Remove underlay
      $("#closePanelUnderlay").remove();
    }
  }
}

// Toggle the brand list content
function toggleBrandsList() {
  const brandListToggle = document.querySelector(
    'a[data-slide="footerBrandList"]'
  );
  if (!brandListToggle) return;

  const slideContent = brandListToggle.dataset.slide;
  const span = brandListToggle.querySelector("span");

  brandListToggle.addEventListener("click", (e) => {
    e.preventDefault(); // Prevent the default action

    const element = document.getElementById(slideContent);
    if (element.classList.contains("brand-list-slide-down")) {
      element.style.maxHeight = null; // Reset max-height
      element.classList.remove("brand-list-slide-down");
      element.classList.add("brand-list-slide-up");
    } else {
      element.style.maxHeight = element.scrollHeight + "px"; // Set max-height to the scroll height of the content
      // Force a reflow to make the transition happen
      element.offsetHeight; // jshint ignore:line
      element.classList.remove("brand-list-slide-up");
      element.classList.add("brand-list-slide-down");
    }
    span.innerText = ["+", "-"].find((s) => s !== span.innerText);
  });
}

// Toggle the locations list content on contact page on mobile devices
function toggleLocationsList() {
  const locationsListToggle = document.querySelector(
    'a[data-slide="locationsCallList"]'
  );
  if (!locationsListToggle) return;

  const slideContent = locationsListToggle.dataset.slide;
  const element = document.getElementById(slideContent);

  // If the device is a mobile device, add the 'locations-list-slide-up' class to the element and show it
  if (window.matchMedia("only screen and (max-width: 760px)").matches) {
    element.classList.add("locations-list-slide-up");
    element.style.visibility = "visible"; // Show the element
  }

  const toggle = (e) => {
    // If the device is a mobile device, prevent the default action
    if (window.matchMedia("only screen and (max-width: 760px)").matches) {
      e.preventDefault(); // Prevent the default action
    }

    if (element.classList.contains("locations-list-slide-down")) {
      element.style.maxHeight = null; // Reset max-height
      element.classList.remove("locations-list-slide-down");
      element.classList.add("locations-list-slide-up");
    } else {
      element.style.maxHeight = element.scrollHeight + "px"; // Set max-height to the scroll height of the content
      // Force a reflow to make the transition happen
      element.offsetHeight; // jshint ignore:line
      element.classList.remove("locations-list-slide-up");
      element.classList.add("locations-list-slide-down");
    }
  };

  locationsListToggle.addEventListener("touchstart", toggle);
}

const productFilters = {
  init: function () {
    this.filterContainer = document.querySelector(".filter-aside");
    this.exitFilters = document.querySelector(".refineVariables");
    this.clearFilters = document.querySelector(".filter-links .clear-filters");
    const catalogWrapper = document.querySelector(".catalogWrapper");
    this.narrowBy = catalogWrapper
      ? Array.from(catalogWrapper.getElementsByClassName("narrowBy-"))
      : [];

    this.initialPriceSliderValues = [
      parseInt(
        document.querySelector(".pricesFilterAmountMin input")?.dataset
          ?.minValue ?? 0
      ),
      parseInt(
        document.querySelector(".pricesFilterAmountMax input")?.dataset
          ?.maxValue ?? 0
      ),
    ];
    this.initialWidthSliderValues = [
      parseInt(
        document.querySelector(".widthsFilterAmountMin input")?.dataset
          ?.minValue ?? 0
      ),
      parseInt(
        document.querySelector(".widthsFilterAmountMax input")?.dataset
          ?.maxValue ?? 0
      ),
    ];
    this.initialHeightSliderValues = [
      parseInt(
        document.querySelector(".heightsFilterAmountMin input")?.dataset
          ?.minValue ?? 0
      ),
      parseInt(
        document.querySelector(".heightsFilterAmountMax input")?.dataset
          ?.maxValue ?? 0
      ),
    ];
    this.initialDepthSliderValues = [
      parseInt(
        document.querySelector(".depthsFilterAmountMin input")?.dataset
          ?.minValue ?? 0
      ),
      parseInt(
        document.querySelector(".depthsFilterAmountMax input")?.dataset
          ?.maxValue ?? 0
      ),
    ];
  },
  hideDuplicateFilters: function () {
    function processDuplicateFilters(container) {
      const groupCounts = new Map();
      const groupFilterCounts = new Map();
      const listItems = document.querySelectorAll(
        `${container}.filterGroup ul li`
      );

      listItems.forEach((li) => {
        // Check if the internal code has already been run for this element
        if (li.dataset.processed === "true") {
          return;
        }

        const groupVal = li.getAttribute("data-group");
        const filterCountSpan = li.querySelector("label .filterCount");
        const filterCount = filterCountSpan
          ? parseInt(filterCountSpan.textContent.replace(/[()]/g, ""))
          : 0;
        if (groupCounts.has(groupVal) && groupVal != null) {
          const count = groupCounts.get(groupVal);
          groupCounts.set(groupVal, count + 1);
          li.classList.add("d-none");
          if (!isNaN(filterCount)) {
            const totalFilterCount =
              groupFilterCounts.get(groupVal) + filterCount;
            groupFilterCounts.set(groupVal, totalFilterCount);
          }
        } else {
          groupCounts.set(groupVal, 1);
          groupFilterCounts.set(groupVal, filterCount);
        }

        // Mark the element as processed
        li.dataset.processed = "true";
      });

      // Update the filter counts of the first filter of each group
      document
        .querySelectorAll(`${container}.filterGroup ul li:not(.d-none)`)
        .forEach(function (li) {
          const groupVal = li.getAttribute("data-group");
          const filterCountSpan = li.querySelector("label .filterCount");
          if (filterCountSpan && groupFilterCounts.has(groupVal)) {
            filterCountSpan.textContent =
              "(" + groupFilterCounts.get(groupVal) + ")";
          }
        });
    }

    processDuplicateFilters(".collections");
    processDuplicateFilters(".brands");
  },
  hideDuplicateExitFilters: function () {
    const exits = document.querySelector(".refineVariables>ul");
    if (!exits) return;
    const exitFilters = exits.children;
    const groups = [];
    for (const item of exitFilters) {
      if (groups.includes(item.firstChild.dataset.group)) {
        item.classList.add("d-none");
      } else {
        groups.push(item.firstChild.dataset.group);
      }
    }
  },
  bindClicks: function () {
    const exitFilters = document.querySelectorAll(".filterTag .exitFilter");
    exitFilters.forEach((exitFilter) => {
      // Guard like the checkbox listeners below against duplicate binding.
      if (exitFilter.hasAttribute("data-event-listener-added")) return;
      exitFilter.setAttribute("data-event-listener-added", "true");
      exitFilter.addEventListener("click", function (e) {
        let reloadCatalog = false;
        const thisId = this.id.replace("_tag", "");
        const thisFullId = this.id;
        const thisFilterGroup = this.closest(".filterTag")
          .className.split(" ")[1]
          .replace("Tag", "");
        const thisInput = document.querySelector(
          ".filterGroup." + thisFilterGroup + " input#" + thisId
        );
        productFilters.handleFilterChange(thisInput, e);

        const group = this.dataset.group;
        const exits = document.querySelector(".refineVariables>ul");
        if (!exits) return;
        const allExitFilters = exits.children;
        reloadCatalog = true;

        Array.from(allExitFilters).forEach((item) => {
          // click hidden duplicate exit filters
          if (
            item.firstChild.dataset.group == group &&
            item.firstChild.id !== thisFullId &&
            item.classList.contains("d-none")
          ) {
            item.firstChild.firstChild.click();
          }
          // is filter clicked is a brand, check if any that brand's collections are selected and click those too
          if (thisFilterGroup == "brands") {
            const brandId = thisId.replace("brands_", "");
            if (
              item.firstChild.id.includes("collections_") &&
              item.firstChild.dataset.brand == brandId
            ) {
              item.firstChild.firstChild.click();
            }
          }
          // is brand catalog page and narrow by filters exist
          const isBrandCatalog = document.querySelector(
            ".brandContentContainer"
          );
          const isNarrowBy = document.querySelectorAll(
            ".brandContentContainer .narrowBy"
          );
          if (
            isBrandCatalog &&
            isNarrowBy.length > 0 &&
            thisId.includes("categories_")
          ) {
            const categoryId = thisId.replace("categories_", "");
            isNarrowBy.forEach((narrowBy) => {
              if (narrowBy.dataset.categories == categoryId) {
                narrowBy.classList.remove("selected");
              }
            });
          }
        });

        // Cascaded clicks above (e.g. a brand's collections tags) recurse
        // into this same handler synchronously - e.isTrusted is false for
        // those (only real user clicks are trusted), so only the
        // original click reloads, once, after every cascade has already
        // updated filter state.
        if (reloadCatalog == true && e.isTrusted) {
          loadProductCatalog();
        }
      });
    });
    // add event listener to filter checkboxes
    const checkboxes = document.querySelectorAll(
      ".filter-aside input[type=checkbox]"
    );

    checkboxes.forEach(function (checkbox) {
      if (!checkbox.hasAttribute("data-event-listener-added")) {
        checkbox.addEventListener("change", function (e) {
          productFilters.handleFilterChange(e.target, e);

          // Cascaded duplicate-sync clicks below recurse into this same
          // handler synchronously - checkbox change events don't reliably
          // reflect e.isTrusted for script-triggered clicks, so a reentrancy
          // guard is used instead: only the outermost call cascades and
          // reloads, since its single query already covers every duplicate.
          if (productFilters._syncingDuplicateGroup) return;
          productFilters._syncingDuplicateGroup = true;

          // Check if the checkbox's parent element has the 'collections' or 'brands' class
          function handleGroupElements(containerClass, targetId) {
            if (!targetId.includes(containerClass)) return;
            const group = e.target.parentNode.dataset.group;
            const groupElements = document.querySelectorAll(
              `.${containerClass} ul li.d-none[data-group="${group}"]`
            );

            groupElements.forEach(function (li) {
              const input = li.querySelector('input[type="checkbox"]');
              // .d-none never gets removed just because a duplicate gets
              // checked, so this can re-match an element already synced
              // (including the one that triggered this handler) - only
              // click ones that still disagree, or this re-clicks (and
              // un-checks) a duplicate that's already correct.
              if (input && input.checked !== e.target.checked) {
                input.click();
              }
            });
          }

          handleGroupElements("collections", e.target.id);
          handleGroupElements("brands", e.target.id);

          productFilters._syncingDuplicateGroup = false;
          loadProductCatalog();
          productFilters.hideDuplicateExitFilters();
        });

        checkbox.setAttribute("data-event-listener-added", "true");
      }
    });
    // Clear all filters
    const clearFiltersElements = document.querySelectorAll(
      ".filter-links .clear-filters"
    );
    clearFiltersElements.forEach(function (element) {
      // Same duplicate-binding guard as the listeners above.
      if (element.hasAttribute("data-event-listener-added")) return;
      element.setAttribute("data-event-listener-added", "true");
      element.addEventListener("click", function (e) {
        e.preventDefault();
        productFilters.removeAllFilters(e);
      });
    });
  },
  updateGroupSelect: function () {
    const nestedElements =
      productFilters.filterContainer.querySelectorAll(".nested");
    nestedElements.forEach((list) => {
      const children = list.children;
      const selectedChildren = list.querySelectorAll(".selected");
      if (
        children.length == selectedChildren.length &&
        selectedChildren.length != 0
      ) {
        getSVGIcon(
          "check-square-o",
          "",
          list.previousElementSibling.querySelector(".svg-icon"),
          true
        );
      }
    });
  },
  // Prices Filter
  checkIfPriceFiltersSet: function () {
    const slider = document.getElementById("pricesFilterSlider");
    if (!slider) return false;

    if (slider && slider.noUiSlider) {
      const values = slider.noUiSlider.get();

      return (
        parseInt(values[0]) > this.initialPriceSliderValues[0] ||
        parseInt(values[1]) < this.initialPriceSliderValues[1]
      );
    }

    return false;
  },
  initPriceFilterSlider: function () {
    const slider = document.getElementById("pricesFilterSlider");
    if (!slider) return;

    const minPrice = parseInt(
      document.querySelector(".pricesFilterAmountMin input").value
    );
    const maxPrice = parseInt(
      document.querySelector(".pricesFilterAmountMax input").value
    );

    // Can run more than once per page load - destroy any existing instance first.
    if (slider.noUiSlider) {
      slider.noUiSlider.destroy();
    }

    noUiSlider.create(slider, {
      start: [minPrice, maxPrice],
      step: 10,
      connect: true,
      range: {
        min: this.initialPriceSliderValues[0],
        max: this.initialPriceSliderValues[1],
      },
      margin: 100,
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Math.round(value);
        },
      },
    });

    slider.noUiSlider.on("update", function (values, handle) {
      const minInput = document.querySelector(".pricesFilterAmountMin input");
      const maxInput = document.querySelector(".pricesFilterAmountMax input");
      if (!minInput || !maxInput) return;
      minInput.value = values[0];
      maxInput.value = values[1];
    });

    slider.noUiSlider.on("set", function () {
      const minInput = document.querySelector(".pricesFilterAmountMin input");
      const maxInput = document.querySelector(".pricesFilterAmountMax input");
      if (!minInput || !maxInput) return;
      productFilters.updateCatalogAfterPricesFilterChange(
        minInput.value,
        maxInput.value
      );
      productFilters.updateClearFiltersLink();
    });

    if (productFilters.checkIfPriceFiltersSet()) {
      const accordionPrices = document.getElementById("accordion-prices");
      expandAccordion(accordionPrices);
    }
  },
  initPriceInputChange: function () {
    const inputs = document.querySelectorAll(".pricesFilterContainer input");
    const initialPriceSliderValues = this.initialPriceSliderValues;

    inputs.forEach((input) => {
      if (input.hasAttribute("data-event-listener-added")) return;
      input.setAttribute("data-event-listener-added", "true");
      input.addEventListener("change", function () {
        let value = this.value;
        const initialMin = initialPriceSliderValues[0];
        const initialMax = initialPriceSliderValues[1];
        const slider = document.getElementById("pricesFilterSlider");
        let setMin = initialMin;
        let setMax = initialMax;

        if (!slider || !slider.noUiSlider) return;

        if (this.name == "prices[min]") {
          const currentMaxInput = document.querySelector(
            'input[name="prices[max]"]'
          );
          if (!currentMaxInput) return;
          const currentMax = currentMaxInput.value;
          if (value < initialMin || value > initialMax) {
            value = initialMin;
            const minInput = document.querySelector(".pricesFilterAmountMin input");
            if (minInput) minInput.value = value;
          }
          setMin = parseInt(value);
          setMax = parseInt(currentMax);
          slider.noUiSlider.set([setMin, setMax]);
        } else if (this.name == "prices[max]") {
          const currentMinInput = document.querySelector(
            'input[name="prices[min]"]'
          );
          if (!currentMinInput) return;
          const currentMin = currentMinInput.value;
          if (value > initialMax || value < initialMin) {
            value = initialMax;
            const maxInput = document.querySelector(".pricesFilterAmountMax input");
            if (maxInput) maxInput.value = value;
          }
          setMin = parseInt(currentMin);
          setMax = parseInt(value);
          slider.noUiSlider.set([setMin, setMax]);
        }
        productFilters.updateCatalogAfterPricesFilterChange(setMin, setMax);
      });
    });
  },
  updateCatalogAfterPricesFilterChange: function (sliderMinVal, sliderMaxVal) {
    // Check for change in values
    const minPrice = getUrlParameter("prices[min]");
    const maxPrice = getUrlParameter("prices[max]");
    const setMin = minPrice ? minPrice : this.initialPriceSliderValues[0];
    const setMax = maxPrice ? maxPrice : this.initialPriceSliderValues[1];
    if (setMin !== null && setMax !== null) {
      // Check if values don't match
      if (sliderMinVal != setMin || sliderMaxVal != setMax) {
        // noUiSlider fires "set" per handle - coalesce so the second
        // firing doesn't reload against a form the first firing's shimmer already wiped.
        clearTimeout(productFilters._pricesReloadTimer);
        productFilters._pricesReloadTimer = setTimeout(() => loadProductCatalog(), 0);
      }
    }
  },
  // Width Filter
  checkIfWidthFiltersSet: function () {
    const slider = document.getElementById("widthsFilterSlider");
    if (!slider) return false;

    if (slider && slider.noUiSlider) {
      const values = slider.noUiSlider.get();

      return (
        parseInt(values[0]) > this.initialWidthSliderValues[0] ||
        parseInt(values[1]) < this.initialWidthSliderValues[1]
      );
    }

    return false;
  },
  initWidthFilterSlider: function () {
    const slider = document.getElementById("widthsFilterSlider");
    if (!slider) return;

    const minWidth = parseInt(
      document.querySelector(".widthsFilterAmountMin input").value
    );
    const maxWidth = parseInt(
      document.querySelector(".widthsFilterAmountMax input").value
    );

    // Can run more than once per page load - destroy any existing instance first.
    if (slider.noUiSlider) {
      slider.noUiSlider.destroy();
    }

    noUiSlider.create(slider, {
      start: [minWidth, maxWidth],
      step: 1,
      connect: true,
      range: {
        min: this.initialWidthSliderValues[0],
        max: this.initialWidthSliderValues[1],
      },
      margin: 10,
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Math.round(value);
        },
      },
    });

    slider.noUiSlider.on("update", function (values, handle) {
      const minInput = document.querySelector(".widthsFilterAmountMin input");
      const maxInput = document.querySelector(".widthsFilterAmountMax input");
      if (!minInput || !maxInput) return;
      minInput.value = values[0];
      maxInput.value = values[1];
    });

    slider.noUiSlider.on("set", function () {
      const minInput = document.querySelector(".widthsFilterAmountMin input");
      const maxInput = document.querySelector(".widthsFilterAmountMax input");
      if (!minInput || !maxInput) return;
      productFilters.updateCatalogAfterWidthsFilterChange(
        minInput.value,
        maxInput.value
      );
      productFilters.updateClearFiltersLink();
    });

    if (productFilters.checkIfWidthFiltersSet()) {
      const accordionWidths = document.getElementById("accordion-widths");
      expandAccordion(accordionWidths);
    }
  },
  initWidthInputChange: function () {
    const inputs = document.querySelectorAll(".widthsFilterContainer input");

    inputs.forEach((input) => {
      if (input.hasAttribute("data-event-listener-added")) return;
      input.setAttribute("data-event-listener-added", "true");
      input.addEventListener("change", function () {
        let value = this.value;
        const minInputEl = document.querySelector(".widthsFilterAmountMin input");
        const maxInputEl = document.querySelector(".widthsFilterAmountMax input");
        if (!minInputEl || !maxInputEl) return;
        const initialMin = parseInt(minInputEl.dataset.minValue);
        const initialMax = parseInt(maxInputEl.dataset.maxValue);
        const slider = document.getElementById("widthsFilterSlider");
        if (!slider || !slider.noUiSlider) return;
        let setMin, setMax;

        if (this.name == "widths[min]") {
          const currentMaxInput = document.querySelector(
            'input[name="widths[max]"]'
          );
          if (!currentMaxInput) return;
          const currentMax = currentMaxInput.value;
          if (value < initialMin || value > initialMax) {
            value = initialMin;
            minInputEl.value = value;
          }
          setMin = parseInt(value);
          setMax = parseInt(currentMax);
          slider.noUiSlider.set([setMin, setMax]);
        } else if (this.name == "widths[max]") {
          const currentMinInput = document.querySelector(
            'input[name="widths[min]"]'
          );
          if (!currentMinInput) return;
          const currentMin = currentMinInput.value;
          if (value > initialMax || value < initialMin) {
            value = initialMax;
            maxInputEl.value = value;
          }
          setMin = parseInt(currentMin);
          setMax = parseInt(value);
          slider.noUiSlider.set([setMin, setMax]);
        }
        if (setMin !== undefined && setMax !== undefined) {
          productFilters.updateCatalogAfterWidthsFilterChange(setMin, setMax);
        }
      });
    });
  },
  updateCatalogAfterWidthsFilterChange: function (sliderMinVal, sliderMaxVal) {
    // Check for change in values
    const minWidth = parseInt(getUrlParameter("widths[min]"));
    const maxWidth = parseInt(getUrlParameter("widths[max]"));
    const setMin = minWidth ? minWidth : this.initialWidthSliderValues[0];
    const setMax = maxWidth ? maxWidth : this.initialWidthSliderValues[1];
    if (setMin !== null && setMax !== null) {
      // Check if values don't match
      if (sliderMinVal != setMin || sliderMaxVal != setMax) {
        // noUiSlider fires "set" per handle - coalesce so the second
        // firing doesn't reload against a form the first firing's shimmer already wiped.
        clearTimeout(productFilters._widthsReloadTimer);
        productFilters._widthsReloadTimer = setTimeout(() => loadProductCatalog(), 0);
      }
    }
  },
  // Height Filter
  checkIfHeightFiltersSet: function () {
    const slider = document.getElementById("heightsFilterSlider");
    if (!slider) return false;

    if (slider && slider.noUiSlider) {
      const values = slider.noUiSlider.get();

      return (
        parseInt(values[0]) > this.initialHeightSliderValues[0] ||
        parseInt(values[1]) < this.initialHeightSliderValues[1]
      );
    }

    return false;
  },
  initHeightFilterSlider: function () {
    const slider = document.getElementById("heightsFilterSlider");
    if (!slider) return;

    const minHeight = parseInt(
      document.querySelector(".heightsFilterAmountMin input").value
    );
    const maxHeight = parseInt(
      document.querySelector(".heightsFilterAmountMax input").value
    );

    // Can run more than once per page load - destroy any existing instance first.
    if (slider.noUiSlider) {
      slider.noUiSlider.destroy();
    }

    noUiSlider.create(slider, {
      start: [minHeight, maxHeight],
      step: 1,
      connect: true,
      range: {
        min: this.initialHeightSliderValues[0],
        max: this.initialHeightSliderValues[1],
      },
      margin: 10,
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Math.round(value);
        },
      },
    });

    slider.noUiSlider.on("update", function (values, handle) {
      const minInput = document.querySelector(".heightsFilterAmountMin input");
      const maxInput = document.querySelector(".heightsFilterAmountMax input");
      if (!minInput || !maxInput) return;
      minInput.value = values[0];
      maxInput.value = values[1];
    });

    slider.noUiSlider.on("set", function () {
      const minInput = document.querySelector(".heightsFilterAmountMin input");
      const maxInput = document.querySelector(".heightsFilterAmountMax input");
      if (!minInput || !maxInput) return;
      productFilters.updateCatalogAfterHeightsFilterChange(
        minInput.value,
        maxInput.value
      );
      productFilters.updateClearFiltersLink();
    });

    if (productFilters.checkIfHeightFiltersSet()) {
      const accordionHeights = document.getElementById("accordion-heights");
      expandAccordion(accordionHeights);
    }
  },
  initHeightInputChange: function () {
    const inputs = document.querySelectorAll(".heightsFilterContainer input");

    inputs.forEach((input) => {
      if (input.hasAttribute("data-event-listener-added")) return;
      input.setAttribute("data-event-listener-added", "true");
      input.addEventListener("change", function () {
        let value = this.value;
        const minInputEl = document.querySelector(".heightsFilterAmountMin input");
        const maxInputEl = document.querySelector(".heightsFilterAmountMax input");
        if (!minInputEl || !maxInputEl) return;
        const initialMin = parseInt(minInputEl.dataset.minValue);
        const initialMax = parseInt(maxInputEl.dataset.maxValue);
        const slider = document.getElementById("heightsFilterSlider");
        let setMin, setMax;

        if (!slider || !slider.noUiSlider) return;

        if (this.name == "heights[min]") {
          const currentMaxInput = document.querySelector(
            'input[name="heights[max]"]'
          );
          if (!currentMaxInput) return;
          const currentMax = currentMaxInput.value;
          if (value < initialMin || value > initialMax) {
            value = initialMin;
            const minInput = document.querySelector(".heightsFilterAmountMin input");
            if (minInput) minInput.value = value;
          }
          setMin = parseInt(value);
          setMax = parseInt(currentMax);
          slider.noUiSlider.set([setMin, setMax]);
        } else if (this.name == "heights[max]") {
          const currentMinInput = document.querySelector(
            'input[name="heights[min]"]'
          );
          if (!currentMinInput) return;
          const currentMin = currentMinInput.value;
          if (value > initialMax || value < initialMin) {
            value = initialMax;
            const maxInput = document.querySelector(".heightsFilterAmountMax input");
            if (maxInput) maxInput.value = value;
          }
          setMin = parseInt(currentMin);
          setMax = parseInt(value);
          slider.noUiSlider.set([setMin, setMax]);
        }
        if (setMin !== undefined && setMax !== undefined) {
          productFilters.updateCatalogAfterHeightsFilterChange(setMin, setMax);
        }
      });
    });
  },
  updateCatalogAfterHeightsFilterChange: function (sliderMinVal, sliderMaxVal) {
    // Check for change in values
    const minHeight = parseInt(getUrlParameter("heights[min]"));
    const maxHeight = parseInt(getUrlParameter("heights[max]"));
    const setMin = minHeight ? minHeight : this.initialHeightSliderValues[0];
    const setMax = maxHeight ? maxHeight : this.initialHeightSliderValues[1];
    if (setMin !== null && setMax !== null) {
      // Check if values don't match
      if (sliderMinVal != setMin || sliderMaxVal != setMax) {
        // noUiSlider fires "set" per handle - coalesce so the second
        // firing doesn't reload against a form the first firing's shimmer already wiped.
        clearTimeout(productFilters._heightsReloadTimer);
        productFilters._heightsReloadTimer = setTimeout(() => loadProductCatalog(), 0);
      }
    }
  },

  // Depth Filter
  checkIfDepthFiltersSet: function () {
    const slider = document.getElementById("depthsFilterSlider");
    if (!slider) return false;

    if (slider && slider.noUiSlider) {
      const values = slider.noUiSlider.get();

      return (
        parseInt(values[0]) > this.initialDepthSliderValues[0] ||
        parseInt(values[1]) < this.initialDepthSliderValues[1]
      );
    }

    return false;
  },
  initDepthFilterSlider: function () {
    const slider = document.getElementById("depthsFilterSlider");
    if (!slider) return;

    const minDepth = parseInt(
      document.querySelector(".depthsFilterAmountMin input").value
    );
    const maxDepth = parseInt(
      document.querySelector(".depthsFilterAmountMax input").value
    );

    // Can run more than once per page load - destroy any existing instance first.
    if (slider.noUiSlider) {
      slider.noUiSlider.destroy();
    }

    noUiSlider.create(slider, {
      start: [minDepth, maxDepth],
      step: 1,
      connect: true,
      range: {
        min: this.initialDepthSliderValues[0],
        max: this.initialDepthSliderValues[1],
      },
      margin: 10,
      format: {
        to: function (value) {
          return Math.round(value);
        },
        from: function (value) {
          return Math.round(value);
        },
      },
    });

    slider.noUiSlider.on("update", function (values, handle) {
      const minInput = document.querySelector(".depthsFilterAmountMin input");
      const maxInput = document.querySelector(".depthsFilterAmountMax input");
      if (!minInput || !maxInput) return;
      minInput.value = values[0];
      maxInput.value = values[1];
    });

    slider.noUiSlider.on("set", function () {
      const minInput = document.querySelector(".depthsFilterAmountMin input");
      const maxInput = document.querySelector(".depthsFilterAmountMax input");
      if (!minInput || !maxInput) return;
      productFilters.updateCatalogAfterDepthsFilterChange(
        minInput.value,
        maxInput.value
      );
      productFilters.updateClearFiltersLink();
    });

    if (productFilters.checkIfDepthFiltersSet()) {
      const accordionDepths = document.getElementById("accordion-depths");
      expandAccordion(accordionDepths);
    }
  },
  initDepthInputChange: function () {
    const inputs = document.querySelectorAll(".depthsFilterContainer input");

    inputs.forEach((input) => {
      if (input.hasAttribute("data-event-listener-added")) return;
      input.setAttribute("data-event-listener-added", "true");
      input.addEventListener("change", function () {
        let value = this.value;
        const minInputEl = document.querySelector(".depthsFilterAmountMin input");
        const maxInputEl = document.querySelector(".depthsFilterAmountMax input");
        if (!minInputEl || !maxInputEl) return;
        const initialMin = parseInt(minInputEl.dataset.minValue);
        const initialMax = parseInt(maxInputEl.dataset.maxValue);
        const slider = document.getElementById("depthsFilterSlider");
        let setMin, setMax;

        if (!slider || !slider.noUiSlider) return;

        if (this.name == "depths[min]") {
          const currentMaxInput = document.querySelector(
            'input[name="depths[max]"]'
          );
          if (!currentMaxInput) return;
          const currentMax = currentMaxInput.value;
          if (value < initialMin || value > initialMax) {
            value = initialMin;
            const minInput = document.querySelector(".depthsFilterAmountMin input");
            if (minInput) minInput.value = value;
          }
          setMin = parseInt(value);
          setMax = parseInt(currentMax);
          slider.noUiSlider.set([setMin, setMax]);
        } else if (this.name == "depths[max]") {
          const currentMinInput = document.querySelector(
            'input[name="depths[min]"]'
          );
          if (!currentMinInput) return;
          const currentMin = currentMinInput.value;
          if (value > initialMax || value < initialMin) {
            value = initialMax;
            const maxInput = document.querySelector(".depthsFilterAmountMax input");
            if (maxInput) maxInput.value = value;
          }
          setMin = parseInt(currentMin);
          setMax = parseInt(value);
          slider.noUiSlider.set([setMin, setMax]);
        }
        if (setMin !== undefined && setMax !== undefined) {
          productFilters.updateCatalogAfterDepthsFilterChange(setMin, setMax);
        }
      });
    });
  },
  updateCatalogAfterDepthsFilterChange: function (sliderMinVal, sliderMaxVal) {
    // Check for change in values
    const minDepth = parseInt(getUrlParameter("depths[min]"));
    const maxDepth = parseInt(getUrlParameter("depths[max]"));
    const setMin = minDepth ? minDepth : this.initialDepthSliderValues[0];
    const setMax = maxDepth ? maxDepth : this.initialDepthSliderValues[1];
    if (setMin !== null && setMax !== null) {
      // Check if values don't match
      if (sliderMinVal != setMin || sliderMaxVal != setMax) {
        // noUiSlider fires "set" per handle - coalesce so the second
        // firing doesn't reload against a form the first firing's shimmer already wiped.
        clearTimeout(productFilters._depthsReloadTimer);
        productFilters._depthsReloadTimer = setTimeout(() => loadProductCatalog(), 0);
      }
    }
  },

  handleFilterChange: function (filterInput, event) {
    if (filterInput.classList.contains("sudo-option")) {
      // Check the sudo option looks only, do not actually check sudo box
      filterInput.parentElement.classList.toggle("selected");
      const isChecked = filterInput.parentElement.classList.contains("selected");
      const nestedLiElements =
        filterInput.parentElement.querySelectorAll("ul.nested li");

      nestedLiElements.forEach(function (filter) {
        const subFilter = filter.querySelector("input");
        subFilter.checked = isChecked;
        const filterItems = {
          filterInput: subFilter,
          filterInputId: subFilter.id,
          filterInputLi: subFilter.closest("li"),
          filterExit: document.querySelector("#" + subFilter.id + "_tag"),
        };
        if (
          filterInput.parentElement.classList.contains("selected") &&
          !event.target.classList.contains("exitFilter") &&
          !event.target.classList.contains("clear-filters")
        ) {
          getSVGIcon(
            "check-square-o",
            "",
            filterInput.parentElement.querySelector(".svg-icon"),
            true
          );
          productFilters.addFilter(filterItems);
        } else {
          getSVGIcon(
            "square-o",
            "",
            filterInput.parentElement.querySelector(".svg-icon"),
            true
          );
          productFilters.removeFilter(filterItems);
        }
      });
    } else {
      const filterItems = {
        filterInput: filterInput,
        filterInputId: filterInput.id,
        filterInputLi: filterInput.closest("li"),
        filterExit: document.querySelector("#" + filterInput.id + "_tag"),
      };
      if (
        filterInput.checked &&
        !event.currentTarget.classList.contains("exitFilter") &&
        !event.currentTarget.classList.contains("clear-filters")
      ) {
        productFilters.addFilter(filterItems);
      } else {
        productFilters.removeFilter(filterItems);
      }
    }
    if (filterInput.classList.contains("sudo-option")) {
      filterInput.checked = false;
    }
    productFilters.resetPageToOne();
    productFilters.updateClearFiltersLink();
  },
  addFilter: function (filterItems) {
    filterItems.filterInputLi.classList.add("selected");
    getSVGIcon(
      "check-square-o",
      "",
      filterItems.filterInputLi.querySelector(".svg-icon"),
      true
    );
    productFilters.addExitFilter(filterItems);

    if (productFilters.narrowBy.length > 0) {
      const filterGroup = filterItems.filterInputId.split("_")[0];
      const filterId = filterItems.filterInputId.split("_")[1];
      const narrowByElement = productFilters.narrowBy.querySelector(
        ".narrowBy[data-" + filterGroup + '="' + filterId + '"]'
      );
      if (narrowByElement) {
        narrowByElement.classList.add("selected");
      }
    }
  },
  addExitFilter: function (filterItems) {
    const exitFilterHtml =
      '<li class="filterTag ' +
      filterItems.filterInputId.split("_")[0] +
      'Tag"><div class="exitFilter" id="' +
      filterItems.filterInputId +
      '_tag" data-group="' +
      filterItems.filterInputLi.dataset.group +
      '"><div class="svg-icon"></div></div> ' +
      filterItems.filterInputLi.innerText
        .split(/ \([0-9]+\)/)[0]
        .replace("image/svg+xml", "") +
      "</li>";
    let newExitFilter = document.createElement("div");
    newExitFilter.innerHTML = exitFilterHtml.trim();
    newExitFilter = newExitFilter.firstChild;
    document.querySelector(".refineVariables ul").appendChild(newExitFilter);
    newExitFilter.style.display = "none";
    newExitFilter.style.display = "block";
    getSVGIcon(
      "times-circle",
      "",
      newExitFilter.querySelector(".svg-icon"),
      true
    );
  },
  removeFilter: function (filterItems) {
    filterItems.filterInput.checked = false;
    filterItems.filterInput.setAttribute("checked", false);
    const filterInputLi = filterItems.filterInput.closest("li");
    filterInputLi.classList.remove("selected");
    if (!filterInputLi.classList.contains("d-none")) {
      getSVGIcon(
        "square-o",
        "",
        filterInputLi.querySelector(".svg-icon"),
        true
      );
    }
    const filterExitLi = filterItems.filterExit.closest("li");
    filterExitLi.style.opacity = "0";
    setTimeout(() => {
      filterExitLi.remove();
    }, 300);

    if (productFilters.narrowBy.length > 0) {
      const filterGroup = filterItems.filterInputId.split("_")[0];
      const filterId = filterItems.filterInputId.split("_")[1];
      const narrowByElement = productFilters.narrowBy.querySelector(
        ".narrowBy[data-" + filterGroup + '="' + filterId + '"]'
      );
      if (narrowByElement) {
        narrowByElement.classList.remove("selected");
      }
    }
  },
  removeAllFilters: function (e) {
    const checkedCheckboxes = productFilters.filterContainer.querySelectorAll(
      "input[type=checkbox]:checked"
    );
    checkedCheckboxes.forEach((filter) => {
      productFilters.handleFilterChange(filter, e);
    });

    const sudoOptions =
      productFilters.filterContainer.querySelectorAll(".sudo-option");
    sudoOptions.forEach((sudo) => {
      getSVGIcon(
        "square-o",
        "",
        sudo.closest("li").querySelector(".svg-icon"),
        true
      );
    });

    productFilters.resetPricingFilter();
    productFilters.resetWidthFilter();
    productFilters.resetHeightFilter();
    productFilters.resetDepthFilter();
    productFilters.updateClearFiltersLink();
    loadProductCatalog();
  },
  // Guarded like checkIfPriceFiltersSet() etc. - not every page/config has
  // this range facet, and removeAllFilters() calls all four resets in
  // sequence before its final reload.
  resetPricingFilter: function () {
    const slider = document.getElementById("pricesFilterSlider");
    if (!slider) return;
    const initialMin = this.initialPriceSliderValues[0];
    const initialMax = this.initialPriceSliderValues[1];
    slider.noUiSlider.set([initialMin, initialMax]);
    document.querySelector(".pricesFilterAmountMin input").value = initialMin;
    document.querySelector(".pricesFilterAmountMax input").value = initialMax;
  },
  resetWidthFilter: function () {
    const slider = document.getElementById("widthsFilterSlider");
    if (!slider) return;
    const initialMin = this.initialWidthSliderValues[0];
    const initialMax = this.initialWidthSliderValues[1];
    slider.noUiSlider.set([initialMin, initialMax]);
    document.querySelector(".widthsFilterAmountMin input").value = initialMin;
    document.querySelector(".widthsFilterAmountMax input").value = initialMax;
  },
  resetHeightFilter: function () {
    const slider = document.getElementById("heightsFilterSlider");
    if (!slider) return;
    const initialMin = this.initialHeightSliderValues[0];
    const initialMax = this.initialHeightSliderValues[1];
    slider.noUiSlider.set([initialMin, initialMax]);
    document.querySelector(".heightsFilterAmountMin input").value = initialMin;
    document.querySelector(".heightsFilterAmountMax input").value = initialMax;
  },
  resetDepthFilter: function () {
    const slider = document.getElementById("depthsFilterSlider");
    if (!slider) return;
    const initialMin = this.initialDepthSliderValues[0];
    const initialMax = this.initialDepthSliderValues[1];
    slider.noUiSlider.set([initialMin, initialMax]);
    document.querySelector(".depthsFilterAmountMin input").value = initialMin;
    document.querySelector(".depthsFilterAmountMax input").value = initialMax;
  },
  updateClearFiltersLink: function () {
    setTimeout(function () {
      if (
        document.querySelector(".refineVariables").querySelectorAll("li")
          .length > 0 ||
        productFilters.checkIfPriceFiltersSet() ||
        productFilters.checkIfWidthFiltersSet() ||
        productFilters.checkIfHeightFiltersSet() ||
        productFilters.checkIfDepthFiltersSet()
      ) {
        productFilters.clearFilters.style.display = "block";
        productFilters.clearFilters.style.opacity = "1";
        productFilters.clearFilters.style.transition = "opacity 400ms";
      } else {
        productFilters.clearFilters.style.opacity = "0";
        productFilters.clearFilters.style.transition = "opacity 400ms";
        setTimeout(
          () => (productFilters.clearFilters.style.display = "none"),
          400
        );
      }
    }, 400);
  },
  resetPageToOne: function () {
    document.querySelector("#pageNum").value = 1;
  },
};

function initializeSearchSuggestions() {
  // Top bar search suggester
  const topBarSearch = new SearchSuggester(".searchBar .searchbox");
  topBarSearch.init();

  // Top bar search suggester that stays open
  const stayOpenSearch = new SearchSuggester(".searchBar-stayOpen .searchbox");
  stayOpenSearch.init();

  // Mobile search suggester
  const mobileSearch = new SearchSuggester(".mobileSearch .searchbox");
  mobileSearch.init();

  // Result page search suggester
  const resultPageSearch = new SearchSuggester("#search-form");
  resultPageSearch.init();
}

function calcHeaderOffset() {
  const r = document.querySelector(":root");
  const header = document.querySelector("header");
  // check if header is alpine header (no need to calculate offset)
  if(header.classList.contains("alpine-header")) {
    return;
  }
  const nav = document.querySelector(".mainNav");
  const mobileNav = document.querySelector(".mobile-nav");
  const headerHeight = header.offsetHeight;
  const navHeight =
    window.innerWidth >= 992 ? nav.offsetHeight : mobileNav.offsetHeight;
  const headerOffset = headerHeight - navHeight;
  r.style.setProperty("--header-offset", `-${headerOffset + 0.1}px`);

  const resizeObserver = new ResizeObserver((entries) => {
    for (let entry of entries) {
      const cr = entry.contentRect;
      const headerHeight = cr.height;
      const navHeight =
        window.innerWidth >= 992 ? nav.offsetHeight : mobileNav.offsetHeight;
      const headerOffset = headerHeight - navHeight;
      r.style.setProperty("--header-offset", `-${headerOffset + 0.1}px`);
    }
  });

  resizeObserver.observe(header);
}

function pinMobileSearch() {
  const mobileNav = document.querySelector(".mobile-nav");
  const mobileSearch = document.querySelector(".mobileSearch");
  if (!mobileSearch || !mobileNav) return;

  const observer = new IntersectionObserver(
    ([e]) => mobileSearch.classList.toggle("fixed", e.intersectionRatio < 1),
    { threshold: [1] }
  );

  observer.observe(mobileNav);
}

function placeOrderOverlayText() {
  // commmented out variable for easier testing
  // const placeOrderBtn = document.querySelector("#continueToPaymentButton");
  const placeOrderBtn = document.querySelector("#placeOrderButton");
  if (!placeOrderBtn) return;

  placeOrderBtn.addEventListener("click", function () {
    const loadingOverlay = document.getElementById("loadingOverlay");
    if (loadingOverlay) {
      loadingOverlay.style.setProperty("--display", "block");
    }
  });
}

function applyProtectionPlanProductPage() {
  const productPage = document.querySelector(".single-product");
  if (!productPage) return;

  const includeBtns = document.querySelectorAll(
    ".applyProtectionPlanProductPage"
  );
  if (!includeBtns) return;

  for (let i = 0; i < includeBtns.length; i++) {
    includeBtns[i].addEventListener("click", function () {
      const plan = includeBtns[i].dataset.plan;
      const hiddenInput = document.querySelector(
        `input[name="protectionPlan_${plan}"]`
      );
      const icon = document.querySelector(`#protectionPlanIcon_${plan}`);
      // hide button
      includeBtns[i].style.display = "none";
      // show remove
      document.querySelector(`#protectionPlanRemove_${plan}`).style.display =
        "inline-block";
      // set hidden input to true so plan can be added to cart
      hiddenInput.value = true;
      // update icon
      icon.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield-check"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/><path d="m9 12 2 2 4-4"/></svg>';
    });
  }
}

function initializeCustomizeItButton() {
    const productPage = document.querySelector(".single-product");
    if (!productPage) return;

    const customizeButtons = productPage.querySelectorAll(".customizable-button");
    customizeButtons.forEach((button) => {
        // Find the next sibling with class "modal-msg"
        let modalMsg = button.nextElementSibling;
        // Skip non-element nodes and look for the correct sibling
        while (modalMsg && !(modalMsg.classList && modalMsg.classList.contains("modal-msg"))) {
            modalMsg = modalMsg.nextElementSibling;
        }
        if (modalMsg) {
            button.addEventListener("click", function (e) {
                e.preventDefault();
                modalMsg.classList.remove("hide");
            });
        }
    });
}

function removeProtectionPlanProductPage() {
  const productPage = document.querySelector(".single-product");
  if (!productPage) return;

  const removeBtns = document.querySelectorAll(
    ".removeProtectionPlanProductPage"
  );
  if (!removeBtns) return;

  for (let i = 0; i < removeBtns.length; i++) {
    removeBtns[i].addEventListener("click", function () {
      const plan = removeBtns[i].dataset.plan;
      const hiddenInput = document.querySelector(
        `input[name="protectionPlan_${plan}"]`
      );
      const icon = document.querySelector(`#protectionPlanIcon_${plan}`);
      // hide remove
      removeBtns[i].style.display = "none";
      // show button
      document.querySelector(`#protectionPlanButton_${plan}`).style.display =
        "inline-block";
      // set hidden input to true so plan can be added to cart
      hiddenInput.value = false;
      // update icon
      icon.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/></svg>';
    });
  }
}

function slidePanelProtectionPlanProductPage() {
  const productPage = document.querySelector(".single-product");
  if (!productPage) return;

  const slidePanelBtns = document.querySelectorAll(".protectionPlanWhatsCovered");
  if (!slidePanelBtns) return;

  for (let i = 0; i < slidePanelBtns.length; i++) {
    slidePanelBtns[i].addEventListener("click", function () {
      const variantId = slidePanelBtns[i].dataset.variantid;
      const protectionPlanId = slidePanelBtns[i].dataset.ppid;
      // get and display slide panel
      const url = new URL(globalObject.url + "ajax/product-catalog.php");
      url.searchParams.append("action", "displayProtectionPlanSlidePanel");
      url.searchParams.append("protectionPlanId", protectionPlanId);
      url.searchParams.append("variantId", variantId);
      
      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          document.body.insertAdjacentHTML('beforeend', data);
          const slidePanelId = `#displayProtectionPlanSlidePanel_${protectionPlanId}`;
          setTimeout(function () {
            toggleSlidePanel(slidePanelId, "open");
          }, 300);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }
}

// Display monthly payment option modal on catalog page
function displayCatalogModal(variantId) {
  const modalContainer = document.createElement("div");
  document.body.append(modalContainer);

  const url = new URL(globalObject.url + "ajax/product-catalog.php");
  url.search = new URLSearchParams({
    action: "getMonthlyPaymentCatalogPage",
    variantId,
  });

  fetch(url, {
    method: "GET",
  })
    .then((response) => response.text())
    .then((paymentOption) => {
      if (paymentOption) {
        modalContainer.innerHTML = paymentOption;
      }
    });
}

function catalogModal() {
  const modalBtns = document.getElementsByClassName("catalog-modal-btn");
  if (!modalBtns) return;

  for (let btn of modalBtns) {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      const variantId = btn.dataset.variantid;
      displayCatalogModal(variantId);
    });
  }
}

function staffPageReadMore() {
  // Staff Read More
  document.querySelectorAll(".read_more").forEach(function (readMoreBtn) {
    readMoreBtn.addEventListener("click", function (e) {
      const staffInfo = this.closest(".staffInfo");
      const staffAbout = staffInfo.querySelector(".staffAbout");
      staffAbout.classList.remove("ellipsis");
      staffAbout.classList.add("ellipsis-show");
      this.style.display = "none";
      this.nextElementSibling.style.display = "block";
    });
  });

  // Staff Read Less
  document.querySelectorAll(".read_less").forEach(function (readLessBtn) {
    readLessBtn.addEventListener("click", function (e) {
      const staffInfo = this.closest(".staffInfo");
      const staffAbout = staffInfo.querySelector(".staffAbout");
      staffAbout.classList.add("ellipsis");
      staffAbout.classList.remove("ellipsis-show");
      document.querySelectorAll(".read_more").forEach(function (readMoreBtn) {
        readMoreBtn.style.display = "block";
      });
      document.querySelectorAll(".read_less").forEach(function (readLessBtn) {
        readLessBtn.style.display = "none";
      });
    });
  });
}

// Delegated from document, not bound directly to .filterBtn - that element
// lives inside .catalogContainer, which fetchProductListing() replaces
// wholesale (shimmer -> real listing), destroying any listener bound to the
// original node.
function toggleFiltersOnMobile() {
  document.addEventListener("click", (e) => {
    if (e.target.closest(".filterBtn")) {
      e.preventDefault();
      toggleFilters();
    }
  });
}

function handleSortingBarChange() {
  document
    .querySelectorAll(
      ".sortBySection select#filterDropdown, .sortBySection select#intervalDropdown"
    )
    .forEach((selectElement) => {
      if (selectElement.hasAttribute("data-event-listener-added")) return;
      selectElement.setAttribute("data-event-listener-added", "true");
      selectElement.addEventListener("change", function () {
        if (this.closest(".sortBySection").classList.contains("curated")) {
          return;
        } else {
          // Reset pagination to page 1
          document.querySelector("#pageNum").value = 1;
          loadProductCatalog(true);
        }
      });
    });
}

function handlePaginationClick() {
  document.addEventListener("click", (e) => {
    const paginationElement = e.target.closest('.pagination');
    if (
      paginationElement &&
      !paginationElement.classList.contains("curated")
    ) {
      e.preventDefault();
      const pageElement = e.target.closest('li');
      const pageNum = pageElement ? pageElement.dataset.page : null;
      if (pageNum) {
        // Update page number
        document.querySelector("#pageNum").value = parseInt(pageNum);
        // Scroll happens in step with the click, alongside the shimmer repaint.
        const headerHeight =
          document.querySelector("header")?.offsetHeight - 100 ?? 0;
        window.scrollTo({
          top: headerHeight,
          behavior: "smooth",
        });
        // Reload products
        loadProductCatalog(true);
      }
    }
  });
}

function product360Viewer() {
  // Product 360 viewer
  document
    .querySelectorAll(".swiper-item-images .spin360View")
    .forEach((item) => {
      item.addEventListener("click", function () {
        if (this.classList.contains("library-cylindo")) {
          // Cylindo

          // Declare the variable that will hold the 360 HD Viewer instance
          let viewerInstance = null;

          // Get options from data attribute
          const options = this.dataset.options
            ? JSON.parse(this.dataset.options)
            : null;

          if (options) {
            // The opts object should hold the start properties of the 360 HD Viewer
            const opts = {
              containerID: "#cylindo-viewer",
              features: [
                "UPHOLSTERY",
                document
                  .querySelector(".upholstery .selected")
                  .getAttribute("data-feature-value"),
              ],
              ...options,
            };

            // Make sure the cylindo framework has been "installed"
            if (cylindo) {
              // Do not instantiate the viewer until the framework reports ready.
              cylindo.on("ready", function () {
                // Create the instance
                viewerInstance = cylindo.viewer.create(opts);
              });
            }

            // Update title to display selected upholstery
            const selectedUpholstery = document
              .querySelector(".upholstery .selected")
              .getAttribute("data-feature-value");
            document.querySelector(
              "h4.variation-heading span.selected"
            ).textContent = selectedUpholstery;

            // Variation selection handler
            document.querySelectorAll(".variation").forEach((variation) => {
              variation.addEventListener("click", function () {
                // Remove the class "selected" from all li elements
                this.parentElement
                  .querySelectorAll("li")
                  .forEach((li) => li.classList.remove("selected"));
                // Add the class "selected" to the current clicked element
                this.classList.add("selected");

                const upholsteryType = document
                  .querySelector(".upholstery")
                  .getAttribute("data-feature-type");
                const upholsteryValue = document
                  .querySelector(".upholstery .selected")
                  .getAttribute("data-feature-value");

                // Create array with values from the selected ones
                const featureArray = [upholsteryType, upholsteryValue];
                // This viewer function sends an array with the new selected features
                viewerInstance.setFeatures(featureArray);

                // Update title to display selected upholstery
                document.querySelector(
                  "h4.variation-heading span.selected"
                ).textContent = upholsteryValue;
              });
            });
          }
        }
      });
    });
}

function handleTestimonialsStars() {
  // Select all list items within the star ratings select
  const starRatings = document.querySelectorAll("ul.star-ratings-select li");
  const hiddenRatingInput = document.querySelector("input[type=hidden]#rating");

  starRatings.forEach((star) => {
    // Mouseover event
    star.addEventListener("mouseover", function () {
      this.classList.add("hovered");
      let previous = this.previousElementSibling;
      while (previous) {
        previous.classList.add("hovered");
        previous = previous.previousElementSibling;
      }
    });

    // Mouseout event
    star.addEventListener("mouseout", function () {
      this.classList.remove("hovered");
      let previous = this.previousElementSibling;
      while (previous) {
        previous.classList.remove("hovered");
        previous = previous.previousElementSibling;
      }
    });

    if (!hiddenRatingInput) return;

    // Click event
    star.addEventListener("click", function () {
      const index = Array.from(starRatings).indexOf(this);
      hiddenRatingInput.value = index + 1; // Set the hidden input value

      // Remove 'selected' class from all stars
      starRatings.forEach((s) => s.classList.remove("selected"));

      // Add 'selected' class to the clicked star and all previous stars
      this.classList.add("selected");
      previous = this.previousElementSibling;
      while (previous) {
        previous.classList.add("selected");
        previous = previous.previousElementSibling;
      }
    });
  });
}

// TODO: CONVERT ALL THIS TO VANILLA FUNCTIONS AND MOVE TO DOMCONTENTLOADED
$(document).ready(function () {
  //Slide panel <button class="slidePanel" data-target="#thisSlidePanel"></button> <div class="slidePanel" id="thisSlidePanel"></div>
  $("a.slidePanel, button.slidePanel").on("click", function (e) {
    e.preventDefault();
    var a_href = $(this).attr("href");
    var button_data = $(this).data("target");
    var target = a_href && a_href.length > 0 ? a_href : button_data;
    if (target && target.length > 0) {
      var panel = $(target);
      toggleSlidePanel(target, "open");
    }
  });
  //Reset 100vh
  window.addEventListener("resize", () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  });

  // MOBILE NAVIGATION
  // TODO: This will be replaced with Alpine.js
  $(window).resize(function () {
    /* if ($(window).width() >= 1024) {
			$('.navContainer').css({'width': '100%'});
			$('.navContainer').css({'display': 'block'});
		} else {
			$('.navContainer').css({'width': '0%'});
			$('.navContainer').css({'display': 'none'});
		} */
  });
  $("#menuBtn").on("click", function () {
    //Open menu
    $(".navContainer").show();
    $(".navContainer").animate({ width: "90%" });
    //Darken
    $("body")
      .addClass("notFixedPosition")
      .addClass("slidePanel-showing")
      .addClass("darken");
    //Append clickable element to close slide panel
    $("body").append('<div id="closePanelUnderlay"></div>');
    //$('html').addClass("fixedPosition");
  });
  $(".navContainer")
    .find(".closebtn")
    .on("click", function () {
      //Close panel
      $(".navContainer").animate({ width: "0%" });
      $(this).siblings(".dropdown").css({ visibility: "hidden" });
      $("body").removeClass("notFixedPosition");
      //$('html').removeClass("fixedPosition");
      $(".navContainer").delay(200).hide(0);
      //Un-darken
      $("body").removeClass("slidePanel-showing").removeClass("darken");
      //Remove underlay
      $("#closePanelUnderlay").remove();
    });
  $(".slideOpen").on("click", function () {
    $(this).siblings(".dropdown").slideToggle("slow");
    $(this).siblings(".dropdown")[0].scrollIntoView(false);
    $(this).siblings(".dropdown").css({ visibility: "visible" });
    $(this).parents("li").siblings().find(".dropdown").slideUp("slow");
    $(this).find("img.rotate").toggleClass("down");
    $(this).parents("li").siblings().find("img.rotate").removeClass("down");
  });
  $(".slideShopNav").on("click", function () {
    $(".slide-shop-buttons").animate({ marginLeft: "-90vw" });
    $("header .mobileNavSlider").animate({ marginLeft: "-90vw" });
    $("#shop, #departments").parents("nav").animate({ marginLeft: "-100%" });
    $("#shop nav, #departments nav").animate({ left: "0%" });
  });
  $("body").on("click", ".backShopNavLevel1", function () {
    $(".slide-shop-buttons").animate({ marginLeft: "0" });
    $("header .mobileNavSlider").animate({ marginLeft: "0" });
    $(".subNav").animate({ marginLeft: "0%" });
    $(".has-subnav nav").animate({ left: "100%" });
  });
  $("body").on("click", ".backShopNavLevel2", function () {
    $(".mainNavLink").next(".dropdown").hide();
    $(".mainNavLink").parent("li").show();
    $(".mainNavLink")
      .show()
      .animate({ marginLeft: "0vw", width: "show" })
      .removeClass("active");
    $(this).removeClass("backShopNavLevel2").addClass("backShopNavLevel1");
  });
  //Anchor animating :: Example: <a href="#anchor-NAME"></a> <a name="anchor-NAME"></a>
  $("a[href*='#anchor-']").click(function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = $(this.hash);
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) {
        let mobileNav = $(".mobile-nav");
        let targetTop = mobileNav.is(":visible")
          ? target.offset().top - mobileNav.outerHeight()
          : target.offset().top - $(".navContainer").height();
        $("html,body").animate(
          {
            scrollTop: targetTop,
          },
          500
        );
        return false;
      } else {
        target = target.length ? target : $("[id=" + this.hash.slice(1) + "]");
        $("html,body").animate(
          {
            scrollTop: target.offset().top - $(".navContainer").height(),
          },
          500
        );
      }
    }
  });

  //Check for window resize
  checksize();
  $(window).resize(checksize);

  toggleBrandsList();
  // //Product reviews
  // productReviews.init();

  // tabs on product page
  jQuery(".tabs .tab-links a").on("click", function (e) {
    var currentAttrValue = jQuery(this).attr("href");

    // Show/Hide Tabs
    jQuery(".tabs " + currentAttrValue)
      .show()
      .siblings()
      .hide();

    // Change/remove current tab to active
    jQuery(this)
      .parent("li")
      .addClass("active")
      .siblings()
      .removeClass("active");

    e.preventDefault();
  });

  // //Accordion
  // initializeAccordion();

  //Expand the product info accordion on product pages on load
  let productInfo = document.getElementById("accordion-productInfo");
  let productWrapper = document.querySelector(".productWrapper");

  if (productInfo && !productWrapper.classList.contains("inactive")) {
    expandAccordion(productInfo);
  }

  //Initiate mattress sizes functions
  var mattressSizes = new MattressSizes();
  mattressSizes.init();

  //Initiate cross sells function
  // var crossSells = new CrossSells();
  // crossSells.init();

  // rearranging elements on product page for mobile and tablet
  /*  if ($(window).width() < 420) {
    	$('.productShare').insertBefore('.productInfo');
    }
	$(window).resize(function () {
	    if ($(window).width() < 420) {
	    	$('.productShare').insertBefore('.productInfo');
	    } else {
	    	$('.productShare').insertAfter('.productInfo');
	    }
	});
	if ($(window).width() < 770 && $(window).width() > 420) {
    	$('.productShare').insertBefore('.productDescription');
    }
	$(window).resize(function () {
	    if ($(window).width() < 770 && $(window).width() > 420) {
	    	$('.productShare').insertBefore('.productDescription');
	    } else {
	    	$('.productShare').insertAfter('.productInfo');
	    }
	});*/

  $(".page-order-history .orderDetails .paymentMethod a.seeDetails").click(
    function (e) {
      e.preventDefault();
      $(this).hide().closest(".paymentMethod").find(".details").slideDown();
    }
  );

  // PRODUCT PAGE POPUP
  if ($.fn.modal) {
    $("#fade").modal({
      fadeDuration: 100,
    });
  }

  //Video overlay play/pause
  $(".itemImages .video a, .specials-grid__item__video a").click(function () {
    //Check video type
    let overlay = $($(this).attr("href"));
    if (overlay.find("video").length > 0) {
      //Play HTML video on click
      overlay.find("video").trigger("play");
    } else if (
      overlay.find("iframe").length > 0 &&
      overlay.find("iframe").attr("src").indexOf("youtube") !== false
    ) {
      //Play YouTube video on click
      var vidSrc = overlay
        .find("iframe")
        .prop("src")
        .replace("autoplay=0", "autoplay=1");
      overlay.find("iframe").prop("src", vidSrc);
    }
  });
  $("body").on("click", ".videoOverlay .close-modal", function () {
    //Check video type
    let overlay = $(this).closest(".videoOverlay");
    if (overlay.find("video").length > 0) {
      //Pause HTML video when closing the overlay
      overlay.find("video").trigger("pause");
    } else if (
      overlay.find("iframe").length > 0 &&
      overlay.find("iframe").attr("src").indexOf("youtube") !== false
    ) {
      //Pause YouTube video when closing the overlay
      var vidSrc = overlay
        .find("iframe")
        .prop("src")
        .replace("autoplay=1", "autoplay=0");
      overlay.find("iframe").prop("src", vidSrc);
    }
  });

  //Product 360 viewer
  // $(".swiper-item-images")
  //   .find(".spin360View")
  //   .click(function () {
  //     if ($(this).hasClass("library-cylindo")) {
  //       //Cylindo

  //       // declare the variable that will hold the 360 HD Viewer instance
  //       var viewerInstance = null;
  //       // get options from data attribute
  //       const options = $(this).data("options");
  //       if (options) {
  //         // the opts object should hold the start properties of the 360 HD Viewer
  //         var opts = {
  //           ...{
  //             containerID: "#cylindo-viewer",
  //             features: [
  //               "UPHOLSTERY",
  //               $(".upholstery .selected").attr("data-feature-value"),
  //             ],
  //           },
  //           ...options,
  //         };

  //         // make sure the cylindo framework has been "installed"
  //         if (cylindo) {
  //           // do not instantiate the viewer until the framework reports ready.
  //           cylindo.on("ready", function () {
  //             // create the instance
  //             viewerInstance = cylindo.viewer.create(opts);
  //           });
  //         }

  //         //Update title to display selected upholstery
  //         $("h4.variation-heading")
  //           .find("span.selected")
  //           .text($(".upholstery .selected").attr("data-feature-value"));

  //         //Variation selection handler
  //         $(".variation").click(function () {
  //           //remove the class "selected" from all li elements
  //           $(this).parent().find("li").removeClass("selected");
  //           //add the class "selected" to the current clicked element
  //           $(this).addClass("selected");

  //           const upholsteryType = $(".upholstery").attr("data-feature-type");
  //           const upholsteryValue = $(".upholstery .selected").attr(
  //             "data-feature-value"
  //           );

  //           //create array with values from the selected ones
  //           var featureArray = [
  //             //get the first feature type name
  //             upholsteryType,
  //             //get the feature value for the feature type above
  //             upholsteryValue,
  //           ];
  //           //this viewer function sends an array with the new selected features
  //           viewerInstance.setFeatures(featureArray);

  //           //Update title to display selected upholstery
  //           $("h4.variation-heading")
  //             .find("span.selected")
  //             .text(upholsteryValue);
  //         });
  //       }
  //     }
  //   });

  /* $("#request, a[href='#request']").click(function() {
	    $('html, body').animate({
	        scrollTop: $(".contact").offset().top-120
	    }, 1000);
	}); */
  //Smooth scrolling
  $("a.smoothScroll").click(function (e) {
    e.preventDefault();
    var target = $(this).attr("href");
    if (target.length > 0) {
      $("html, body").animate(
        {
          scrollTop: $(target).offset().top - 120,
        },
        600
      );
    }
  });

  // $(".writeReview").click(function () {
  //   $("#ex1").css("display", "inline-block");
  //   $("#ex1").fadeTo("slow", 1);
  // });
  // $("ex1 .close-modal").click(function () {
  //   $("#ex1").css("display", "none");
  //   $("#ex1").fadeTo("slow", 0);
  // });

  // $("#ex7 .close-modal").click(function () {
  //   $("#ex7").fadeTo(500, 0);
  //   $("#ex7").css("display", "none");
  // });

  // // Thank You Message for product review form
  // $("#general-contact-review").submit(function () {
  //   // catch the form's submit event
  //   $.ajax({
  //     // create an AJAX call...
  //     data: $(this).serialize(), // get the form data
  //     type: $(this).attr("post"), // GET or POST
  //     url: $(this).attr("action"), // the file to call
  //     success: function (response) {
  //       // on success..
  //       $("#ex1").html(
  //         "<h4 class='thankYouReview'>Thank you for your review!</h4>"
  //       ); // update the DIV
  //     },
  //   });
  //   //return false; // cancel original event to prevent form submitting
  // });

  //Pricing question dropdown
  $(".productInfo .priceQuestion a").click(function (e) {
    e.preventDefault();
    //$(this).closest('.itemPrice').find('.priceNotes').slideDown('fast', function(){ $(this).removeClass('hide'); });
    $(this).addClass("notClickable");
    $(this).closest(".productInfo").find(".priceNotes").removeClass("hide");
  });

  //Initiate store selector class
  var myStoreSelector = new MyStoreSelector();
  myStoreSelector.init();

  $("body").on("click", ".openCallUsSlidePanel", function () {
    $.ajax({
      method: "POST",
      url: globalObject.url + "ajax/locator.php",
      data: { action: "displayCallUsSlidePanel" },
    }).done(function (data) {
      //If panel isn't already on page, append it to body
      if ($(".callUsSlidePanel").length == 0) {
        $("body").append(data);
      }
      //Wait a lil and open the side panel
      setTimeout(function () {
        //Show panel
        var panelId = "#callUsSlidePanel";
        var panel = $(panelId);
        toggleSlidePanel(panelId, "open");
      }, 500);
    });
  });

  //Initiate zip code class
  // var zipCodeChanger = new ZipCodeChanger();
  // zipCodeChanger.init();

  // Update sliding footer after content slide effects.
  function footerSlideUpdate() {
    var counter = 0;
    var footerSlide = setInterval(function () {
      if (counter <= 500) {
        SignupForm.checkOffset();
        counter++;
      } else {
        clearInterval(footerSlide);
      }
    }, 1);
  }

  //Blog Read More Button
  $("main").on("click", ".blogSection #read_more", function () {
    $("#my_tags").removeClass("ellipsis").addClass("ellipsis-show");
    $(this).hide();
    $(this).next().show();
  });

  $("main").on("click", ".blogSection #read_less", function () {
    $("#my_tags").removeClass("ellipsis-show").addClass("ellipsis");
    $(this).hide().delay(500);
    $(this).prev().show().delay(500);
  });

  //Pagination
  $("body").on("click", "ul.blogPagination li", function (e) {
    if ($(e.target).is("li.dots")) {
      return;
    } else {
      //Scroll user to top
      $("html,body").animate(
        {
          scrollTop: $("main").offset().top - $(".navContainer").height(),
        },
        "fast"
      );
      //Update page number
      var page = parseInt($(this).data("page"));
      $("#blogPageNum").data("page", page);
      loadPosts();
    }
  });

  function loadPosts() {
    //load paginated blog page
    let pageNum = { pageNum: $("#blogPageNum").data("page") };
    let startDate = getUrlParameter("startDate");
    let endDate = getUrlParameter("endDate");
    let page =
      $("body").hasClass("page-blog") ||
      $("body").hasClass("page-blogarchive") ||
      $("body").hasClass("page-blogtags")
        ? { action: "getBlogPosts", title: "Blog" }
        : { action: "getPortalPosts", title: "Employee Portal" };
    $.ajax({
      method: "GET",
      url: globalObject.url + "ajax/blog.php?action=" + page.action,
      data: {
        pageNum: $("#blogPageNum").data("page"),
        startDate: startDate,
        endDate: endDate,
      },
    }).done(function (data) {
      const container =
        $("body").hasClass("page-blog") ||
        $("body").hasClass("page-blogarchive") ||
        $("body").hasClass("page-blogtags")
          ? $(".blogContainer")
          : $(".portalContainer");
      if (container.length > 0) {
        container.replaceWith(data);
      }
    });
    var currentUrl = window.location.origin + window.location.pathname;
    var queryString = "";
    var queryString = !$.isEmptyObject(pageNum)
      ? "?pageNum=" + Object.values(pageNum)[0]
      : "";
    queryString += queryString
      ? startDate
        ? "&startDate=" + startDate
        : ""
      : startDate
      ? "?startDate=" + startDate
      : "";
    queryString += queryString
      ? endDate
        ? "&endDate=" + endDate
        : ""
      : endDate
      ? "?endDate=" + endDate
      : "";
    var newLocation = !queryString ? currentUrl : currentUrl + queryString;
    history.pushState(pageNum, page.title, decodeURIComponent(newLocation));
  }

  $(function () {
    if ($("#my_tags").text().length < 50) {
      $("#read_more").hide();
      $("#read_less").hide();
    }
  });

  $(".postShow img").click(function () {
    getSVGIcon("close", "", ".modal .close");
    $(this).after(
      '<div class="blocker"><div class="modal"></i><i class="close"></i><img src="' +
        $(this).attr("src") +
        '" /></div></div>'
    );
  });
  $(document).click(function (e) {
    if (
      !$(".postShow .modal").is(e.target) &&
      $(".postShow .modal").has(e.target).length === 0 &&
      !$(".postShow img").is(e.target)
    ) {
      $(".postShow .blocker").fadeOut(1000).remove();
    }
  });
  $(document).on("click", "i.close", function () {
    $(".postShow .blocker").fadeOut(1000).remove();
  });

  //Read more button
  $(".readmore")
    .addClass("collapsed")
    .after('<a href="#" class="readmoreLink collapsed">Read More</a>');
  $("body").on("click", ".readmoreLink.collapsed", function (e) {
    e.preventDefault();
    //var readmoreHeight = $(this).prev('.readmore').outerHeight();
    $(this)
      .text("Read Less")
      .removeClass("collapsed")
      .addClass("expanded")
      .prev(".readmore")
      .removeClass("collapsed")
      .addClass("expanded")
      .css("max-height", "none");
  });
  $("body").on("click", ".readmoreLink.expanded", function (e) {
    e.preventDefault();
    $(this)
      .text("Read More")
      .removeClass("expanded")
      .addClass("collapsed")
      .prev(".readmore")
      .removeClass("expanded")
      .addClass("collapsed")
      .css("max-height", "200px");
  });
  $(".portal-sections .portal-section")
    .first()
    .children(
      ".portal-snippet, .portal-full-content, .portal-read-more, .portal-read-less"
    )
    .toggle();
  $("body").on("click", ".portal-section", function (e) {
    if (
      !$(".portal-files").is(e.target) &&
      $(".portal-files").has(e.target).length === 0
    ) {
      $(this)
        .children(
          ".portal-snippet, .portal-full-content, .portal-read-more, .portal-read-less"
        )
        .toggle();
    }
  });
  $("body").on("click", "#portal-filter", function () {
    $(".filter-list").toggle();
    $(this).parent().addClass("open");
  });
  $("body.page-employee-portal").click(function (e) {
    if ($(".date-select-container").parent().hasClass("show")) {
      if (
        !$(".date-select-container").is(e.target) &&
        $(".date-select-container").has(e.target).length === 0 &&
        !$(".portal-section").is(e.target) &&
        $(".portal-section").has(e.target).length === 0
      ) {
        $(".date-select-container").parent().addClass("show").hide();
      }
    }
  });
  $("body").on("click", ".portal-archive #custom-range", function () {
    $(".date-select-container").parent().addClass("show").show();
    $(".filter-list").toggle();
  });

  /* FAQs Toggle */
  $(".faq li .question").click(function () {
    $(this).find(".plus-minus-toggle").toggleClass("collapsed");
    $(this).parent().toggleClass("active");
    footerSlideUpdate();
  });

  $(".hoursAll").hide();

  $(".toggleHours").click(function () {
    $(this).siblings(".hoursToday, .hoursAll").slideToggle("slow");
    footerSlideUpdate();
  });

  //Coupon stuff
  $(".couponBanners .moreInfo").click(function (e) {
    e.preventDefault();
    $alertBanner = $(this).closest(".alertBanner");
    $alertBanner.find(".expand").slideToggle("fast");
    $(this).toggleClass("active");
  });

  //Basic Modal Functionality
  // $("body").on("click", ".modal-button", function (e) {
  //   e.preventDefault();
  //   $(this).next(".modal-msg").addClass("show").show().removeClass("hide");
  // });
  // $("body").on("click", ".close-modal", function () {
  //   closeModal($(this));
  // });
  // $(document).on("click", ".blocker.show", function (e) {
  //   console.log(e.target);
  //   if (!$(".modal").is(e.target) && $(".modal").has(e.target).length === 0) {
  //     $(".blocker.show").removeClass("show").hide().addClass("hide");
  //   }
  // });
  /*
	//Back to top button
	$('.backToTop').click(function(){
		$("html,body").animate({ scrollTop: $('body').offset().top }, "fast");
	});
	var lastScrollTop = 0;
	$(window).scroll(function() {
		var backToTop = $('.backToTop');
		if($(window).width() < 1025) {
			var windowTop = $('.mobile-nav').offset().top;
			var currentPosition = $(window).scrollTop();
			var st = $(this).scrollTop();
			if(st < lastScrollTop && currentPosition >= windowTop && windowTop > 0) {
				//Scrolling up
				backToTop.fadeIn();
			} else {
				//Scrolling down
				backToTop.fadeOut();
			}
			lastScrollTop = st;
		}
	});
*/

  //Debug feature
  $(".clickToDebug").click(function () {
    var ajaxData = "";
    //Ajax request
    $.ajax({
      method: "GET",
      url: globalObject.url + "ajax/debug.php?action=debugOverlay",
      data: ajaxData,
    }).done(function (data) {
      //Show debug overlay
      if ($(".debugOverlay").length > 0) {
        $(".debugOverlay").fadeIn();
      } else {
        $("body").append(data).css("display", "none").fadeIn();
      }
      //Register close button
      $(".debugOverlay .close").click(function () {
        $(this)
          .closest(".blocker")
          .fadeOut(300, function () {
            $(this).remove();
          });
      });
      //Debug buttons
      $(".debugOverlay .debugChoices button").click(function () {
        var cookie = $(this).data("cookie");
        if (!getCookie(cookie) || getCookie(cookie) == 0) {
          //Set cookie to true
          setCookie(cookie, 1, 30);
          //Change button
          $(this).text("Unset");
        } else {
          //Unset cookie
          setCookie(cookie, 0, 30);
          //Change button
          $(this).text("Start again");
        }
        window.location = window.location.pathname;
      });
    });
  });

  //Holiday-Bar Close
  $(".holiday-hours-bar .holiday-close").click(function () {
    $(".holiday-hours-bar").css("display", "none");
    sessionStorage.setItem("holiday-close", "true");
  });
  if (sessionStorage.getItem("holiday-close") == "true") {
    $(".holiday-hours-bar").css("display", "none");
  }

  // NEW FOOTER ARROWS AND DROPDOWNS
  if ($(window).width() < 1025) {
    $(".footerNav nav").on("click touch", function () {
      if ($(this).find(".arrow").hasClass("icon-open")) {
        $(this).find(".arrow").removeClass("icon-open");
        $(this).find(".arrow").addClass("icon-close");
        // $(this).find('.footerMobileNav').slideDown(500);
        $(this).find(".footerNav").slideToggle(500);
      } else {
        $(this).find(".arrow").removeClass("icon-close");
        $(this).find(".arrow").addClass("icon-open");
        // $(this).find('.footerMobileNav').slideUp(500);
        $(this).find(".footerNav").slideToggle(500);
      }
    });
  }

  //Shop All Furniture
  $(".shop-all-furniture .parent h6").click(function () {
    $(this).next().slideToggle();
    $(this).find(".arrow").toggleClass("open closed");
    $(this).toggleClass("groupBorder");
    $(this).next().toggleClass("groupBorder");
  });
  $(".shop-all-furniture #brands i").click(function () {
    $(this).prev().toggleClass("brandsMax");
    $(this).next().toggle();
    $(this).toggleClass("open closed");
  });

  // Testimonials PageNation
  $(".testimonial").slice(0, 5).addClass("active");
  $(".testimonial").slice(5, 10).addClass("next-active");
  $(".testimonial").not(".active").hide();
  $("#testimonial-next").click(function () {
    if (!$(".testimonial").last().hasClass("active")) {
      $(".testimonial.prev-active").removeClass("prev-active");
      $(".testimonial.active")
        .removeClass("active")
        .addClass("prev-active")
        .hide();
      $(".testimonial.next-active")
        .removeClass("next-active")
        .addClass("active")
        .show();
      $(".testimonial.active")
        .last()
        .nextAll(".testimonial")
        .slice(0, 5)
        .addClass("next-active");
    }
  });
  $("#testimonial-prev").click(function () {
    if (!$(".testimonial").first().hasClass("active")) {
      $(".testimonial.next-active").removeClass("next-active");
      $(".testimonial.active")
        .removeClass("active")
        .addClass("next-active")
        .hide();
      $(".testimonial.prev-active")
        .removeClass("prev-active")
        .addClass("active")
        .show();
      $(".testimonial.active")
        .first()
        .prevAll(".testimonial")
        .slice(0, 5)
        .addClass("prev-active");
    }
  });

  $(".catalogItem, .product-slider-tile").click(function (e) {
    if (e.target.closest(".wishButton")) return;
    let variant = $($(this).attr("id").split("_")).last()[0];
    pushToDataLayerProductClick("productClick", variant);
  });

  // Check if device is NOT an iOS device:
  if (
    !(
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    )
  ) {
    document.querySelectorAll("a.text-us").forEach((link) => {
      // Replace SMS body parameter with the required format for iOS.
      link.href = link.href.replace("&body=", "?body=");
    });
  }
}); // DOCUMENT AIN'T READY NO MORE

function checkForThirdPartyChat() {
  // Checking for perq, podium or livehelpnow
  const chatExists =
    document.querySelector(".fw-cta-ask-a-question-sidebar") ||
    document.querySelector("#podium-bubble") ||
    document.querySelector("#lhnHocButton");

  if (chatExists) {
    const chatUs = document.querySelectorAll(".helpBox .chatUs");
    if (chatUs.length > 0) {
      chatUs.forEach((chat) => {
        chat.classList.remove("d-none");
        linkToChat.init();
      });
    }
  }
}

const linkToChat = {
  init: function () {
    var btns = document.querySelectorAll(".helpBox .chatUs");
    for (i = 0; i < btns.length; i++) {
      btns[i].addEventListener("click", function (e) {
        e.stopImmediatePropagation();
        linkToChat.chatClick();
      });
    }
  },
  chatClick: function () {
    const podium = document.querySelector(
      "#podium-bubble .ContactBubble__Bubble"
    );
    const perq = document.querySelector(".fw-cta-ask-a-question-sidebar");
    const liveHelpNow = document.querySelector("#lhnHocButton");
    const purechat = document.querySelector("purechat-container");

    if (podium) {
      podium.click();
    } else if (perq) {
      perq.click();
    } else if (liveHelpNow) {
      liveHelpNow.click();
    } else if (purechat) {
      console.log("purechat");
      // Purechat - can't trigger a click as far as I can see because content lies inside an iframe currently/preventon of XSS
    }
  },
};

function getUserAgent() {
  const userAgent = window.navigator.userAgent;
  if (userAgent.indexOf("Edge") > -1 || userAgent.indexOf("Edg") > -1) {
    document.body.classList.add("broweser-edge");
  } else if (userAgent.indexOf("Trident") > -1) {
    document.body.classList.add("browser-ie");
  } else if (userAgent.indexOf("Firefox") > -1) {
    document.body.classList.add("browser-firefox");
  } else if (userAgent.indexOf("Chrome") > -1) {
    document.body.classList.add("browser-chrome");
  } else if (userAgent.indexOf("Safari") > -1) {
    document.body.classList.add("browser-safari");
  }

  if (/windows phone/i.test(userAgent)) {
    document.body.classList.add("mobile-windows-phone");
  } else if (/android/i.test(userAgent)) {
    document.body.classList.add("mobile-android");
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    document.body.classList.add("mobile-ios");
  }
}

function lazyLoadImages() {
  //Lazy load images
  let lazyloadImages;

  if ("IntersectionObserver" in window) {
    lazyloadImages = document.querySelectorAll(".lazy");
    const imageObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          let image = entry.target;
          image.src = image.dataset.src;
          image.classList.remove("lazy");
          imageObserver.unobserve(image);
        }
      });
    });

    lazyloadImages.forEach(function (image) {
      imageObserver.observe(image);
    });
  } else {
    let lazyloadThrottleTimeout;
    lazyloadImages = document.querySelectorAll(".lazy");

    function lazyload() {
      if (lazyloadThrottleTimeout) {
        clearTimeout(lazyloadThrottleTimeout);
      }

      lazyloadThrottleTimeout = setTimeout(function () {
        const scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function (img) {
          if (img.offsetTop < window.innerHeight + scrollTop) {
            img.src = img.dataset.src;
            img.classList.remove("lazy");
          }
        });
        if (lazyloadImages.length == 0) {
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
      }, 20);
    }

    document.addEventListener("scroll", lazyload);
    window.addEventListener("resize", lazyload);
    window.addEventListener("orientationChange", lazyload);
  }
}

// THIS LUNACY NEEDS TO GO
//LOADING AJAX OVERLAY
// TODO: Add loading overlay to ajax requests (that need it)
// $(document).on({
//   ajaxStart: function () {
//     console.log('showLoadingOverlay');
//     showLoadingOverlay();
//   },
//   ajaxStop: function () {
//     console.log('hideLoadingOverlay');
//     hideLoadingOverlay();
//   },
// });

function showLoadingOverlay() {
  if (document.body.classList.contains("loading")) return;
  document.body.classList.add("loading");

  //Show .loadingOverlay if already on page
  const overlay = document.querySelector(".loadingOverlay");
  if (overlay) {
    document
      .querySelector(".loadingOverlay")
      .animate([{ opacity: 0 }, { opacity: 1 }], {
        duration: 50,
        fill: "forwards",
      });
  } else {
    //Create .loadingOverlay
    const loadingOverlay = document.createElement("div");
    loadingOverlay.classList.add("loadingOverlay");
    loadingOverlay.setAttribute("id", "loadingOverlay");
    document.body.appendChild(loadingOverlay);
    document
      .getElementById("loadingOverlay")
      .style.setProperty("--display", "none");
    loadingOverlay.animate([{ opacity: 0 }, { opacity: 1 }], {
      duration: 50,
      fill: "forwards",
    });
  }
}

function hideLoadingOverlay() {
  document.body.classList.remove("loading");
}


/**
 * Adds an item to the wishlist.
 *
 * @param {string} item - The identifier of the item to add to the wishlist.
 * @param {string} wishlist - The wishlist identifier.
 * @returns {Promise<void>} A promise that resolves when the item is added to the wishlist.
 *
 * @throws {Error} If there is an error during the fetch request.
 */
async function addToWishlist(item, wishlist) {
  const data = "wishlist=" + wishlist + "&item=" + item;

  const catalogProductsContainer = document.querySelector(
    ".catalogProductsContainer"
  );
  try {
    if (!catalogProductsContainer) GoogleAnalytics.onAddToWishlist(item);
  } catch (e) {
    console.warn("GA wishlist tracking failed:", e.message);
  }

  try {
    const response = await fetch(
      `${globalObject.url}ajax/account.php?action=wishlist-add&${data}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data,
      }
    );

    const responseText = await response.text();

    switch (responseText) {
      case "0":
        handleWishlistError();
        break;
      case "1":
        handleWishlistSuccess(item);
        break;
      default:
        window.location.href = responseText;
        break;
    }
  } catch (error) {
    console.error("Error:", error);
  }
}


async function removeFromWishlist(item) {
  try {
    const response = await fetch(
      `${globalObject.url}ajax/account.php?action=wishlist-remove-all`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: "item=" + item,
      }
    );

    const responseText = await response.text();

    if (responseText === "1") {
      const wishElements = document.querySelectorAll(
        `.wishButton[data-item='${item}']`
      );
      wishElements.forEach((wishElement) => {
        wishElement.classList.remove("inWishlist");
        wishElement.setAttribute("title", "Add to Wishlist");
        const srOnly = wishElement.querySelector(".sr-only");
        if (srOnly) {
          srOnly.textContent = " Add to Wishlist";
        }
        const span = wishElement.nextElementSibling;
        if (span && span.classList.contains("wishlist-text")) {
          span.classList.remove("inWishlist");
          span.textContent = "Add to wishlist";
        }
      });
    }
  } catch (error) {
    console.error("Error:", error);
  }
}

/**
 * Handles errors related to the wishlist functionality.
 */
function handleWishlistError() {
  const wishlistUnderlay = document.querySelector(".wishlistUnderlay");
  const wishlistErrors = document.querySelectorAll(".wishlistError");
  const wishlistOverlay = document.querySelector(".wishlistOverlay");

  if (wishlistUnderlay && wishlistErrors.length) {
    wishlistErrors.forEach((error) => (error.style.display = "block"));
    wishlistOverlay.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

/**
 * Handles the success state of adding an item to the wishlist.
 *
 * @param {string} item - The identifier of the item added to the wishlist.
 */
function handleWishlistSuccess(item) {
  const wishElements = document.querySelectorAll(
    `.wishButton[data-item='${item}']`
  );
  const wishlistUnderlay = document.querySelector(".wishlistUnderlay");
  const wishlistSuccess = document.querySelector(".wishlistSuccess");
  const wishlistOverlay = document.querySelector(".wishlistOverlay");

  if (wishlistUnderlay && wishlistSuccess) {
    wishlistSuccess.style.display = "block";
    wishlistOverlay.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    setTimeout(() => {
      wishlistUnderlay.style.display = "none";
    }, 2000);
  }
  
  if (wishElements.length > 0) {
    wishElements.forEach((wishElement) => {
      wishElement.classList.add("inWishlist");
      const span = wishElement.nextElementSibling;
      if (span && span.classList.contains("wishlist-text")) {
        span.classList.add("inWishlist");
        span.textContent = "In your wishlist";
      }
    });

  }
}

function tabView(evt, tabID) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("matTabContent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }
  tablinks = document.getElementsByClassName("matTab");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabID).className += " active";
  evt.currentTarget.className += " active";
}

// Stable, module-level function references so document.removeEventListener()
// reliably matches what addEventListener() attached, regardless of which
// path closes the panel - tapping the Filter button again, the X button,
// clicking outside, or Escape. Always re-queries .filter-aside fresh instead
// of closing over a node reference, since a filter selection replaces that
// element wholesale (see the getFilters handler in loadProductCatalog()).
function handleFilterAsideOutsideClick(e) {
  const filterAside = document.querySelector(".filter-aside");
  if (!filterAside) return;
  if (
    (e.target !== filterAside && !filterAside.contains(e.target)) ||
    e.target.classList.contains("close-filters")
  ) {
    toggleFilters();
  }
}

function handleFilterAsideKeydown(e) {
  const filterAside = document.querySelector(".filter-aside");
  if (!filterAside || !filterAside.classList.contains("slide")) {
    document.removeEventListener("keydown", handleFilterAsideKeydown);
    return;
  }
  if (e.keyCode === 9) {
    e.preventDefault();
    const focusableEls = filterAside.querySelectorAll(
      'a[href], button, textarea, input[type="text"], input[type="radio"], input[type="checkbox"], select'
    );
    const focusable = [...focusableEls];
    const index = focusable.indexOf(document.activeElement);
    const nextIndex = index + 1 < focusable.length ? index + 1 : 0;
    focusableEls[nextIndex].focus({ focusVisible: true });
  } else if (e.keyCode === 27) {
    toggleFilters();
  }
}

function toggleFilters() {
  const filterAside = document.querySelector(".filter-aside");
  if (filterAside.classList.contains("slide")) {
    filterAside.classList.remove("slide");
    filterAside.style.left = "-100%";
    document.body.classList.remove("slidePanel-showing", "darken");
    document.removeEventListener("keydown", handleFilterAsideKeydown);
    document.removeEventListener("click", handleFilterAsideOutsideClick, true);
  } else {
    filterAside.classList.add("slide");
    filterAside.style.left = "0";
    document.body.classList.add("slidePanel-showing", "darken");
    document.addEventListener("keydown", handleFilterAsideKeydown);
    document.addEventListener("click", handleFilterAsideOutsideClick, true);
  }
}

function loadProductCatalog(skipFilters = false) {
  // get form elements for catalog sort
  const formElements = Array.from(
    document.querySelectorAll(
      "form[name=catalog-sortby-form], form[name=catalog-sort-form]"
    )
  ).flatMap((form) =>
    Array.from(new FormData(form), ([name, value]) => ({ name, value }))
  );

  // get initial values for form elements
  const rawValues = {
    "prices[min]": document.querySelector(".pricesFilterAmountMin input")
      ?.dataset?.minValue,
    "prices[max]": document.querySelector(".pricesFilterAmountMax input")
      ?.dataset?.maxValue,
    "widths[min]": document.querySelector(".widthsFilterAmountMin input")
      ?.dataset?.minValue,
    "widths[max]": document.querySelector(".widthsFilterAmountMax input")
      ?.dataset?.maxValue,
    "heights[min]": document.querySelector(".heightsFilterAmountMin input")
      ?.dataset?.minValue,
    "heights[max]": document.querySelector(".heightsFilterAmountMax input")
      ?.dataset?.maxValue,
    "depths[min]": document.querySelector(".depthsFilterAmountMin input")
      ?.dataset?.minValue,
    "depths[max]": document.querySelector(".depthsFilterAmountMax input")
      ?.dataset?.maxValue,
  };

  // remove null and undefined values
  const initialValues = Object.fromEntries(
    Object.entries(rawValues)
      .filter(([key, value]) => value !== null && value !== undefined)
      .map(([key, value]) => [key, parseInt(value)])
  );

  let groups = {};

  const filteredFormElements = formElements
    .map((element) => {
      // remove $ from value
      if (element.value.includes("$")) {
        element.value = element.value.replace("$", "");
      }

      // group elements by base name
      const baseName = element.name.split("[")[0];
      if (!groups[baseName]) {
        groups[baseName] = [];
      }
      groups[baseName].push(element);

      return element;
    })
    .filter((element) => {
      // remove if both elements of a pair equal their initial value
      const baseName = element.name.split("[")[0];
      if (
        groups[baseName].every(
          (el) => parseInt(el.value) === initialValues[el.name]
        )
      ) {
        return false;
      }

      // remove pageNum element if it's the only element and its value is "1"
      return !(
        formElements.length === 1 &&
        element.name === "pageNum" &&
        element.value === "1"
      );
    });

  // get current page
  const pageSplit = window.location.pathname.split("/");
  const currentPage = pageSplit[pageSplit.length - 1];
  const rawPage =
    currentPage.length !== 0 ? currentPage.replace("shop-", "") : "index";

  if (rawPage === "search" && getUrlParameter("q").length > 0) {
    const searchQuery = {
      name: "q",
      value: getUrlParameter("q"),
    };
    filteredFormElements.unshift(searchQuery);
  }

  // build form data
  const params = new URLSearchParams();
  filteredFormElements.forEach(({ name, value }) => {
    params.append(name, value);
  });

  // get current category
  const category = pageSplit[1].includes("shop-")
    ? pageSplit[1].replace("shop-", "") === "all"
      ? ""
      : pageSplit[1].replace("shop-", "")
    : "";

  // build ajax data
  const ajaxData = params.toString();

  // update URL
  const currentUrl = window.location.origin + window.location.pathname;
  const newLocation =
    ajaxData.length > 0 ? currentUrl + "?" + ajaxData : currentUrl;
  history.pushState(
    ajaxData,
    "Product Catalog",
    decodeURIComponent(newLocation)
  );

  // build URLs and params for ajax request
  const loadProductCatalogUrl =
    globalObject.url +
    "ajax/product-catalog.php?action=loadProductCatalog&page=" +
    rawPage +
    "&category=" +
    category;
  const getCatalogTitleUrl =
    globalObject.url +
    "ajax/product-catalog.php?action=getCatalogTitle&page=" +
    rawPage +
    "&category=" +
    category;
  const getFiltersUrl =
    globalObject.url +
    "ajax/product-catalog.php?action=getFilters&page=" +
    rawPage +
    "&category=" +
    category;

  showListingShimmer();
  if (!skipFilters) {
    showFilterAsideShimmer();
  }

  // Count has no data dependency on the listing/filters fetches below, so it
  // fires immediately, in parallel with them.
  fetchCatalogCount();

  const catalogRequests = [
    // update catalog container via ajax
    fetch(loadProductCatalogUrl + "&" + ajaxData)
      .then((response) => response.text())
      .then((data) => {
        // update product container
        const catalogContainer = document.querySelector(
          ".catalogProductDisplay > .catalogContainer"
        );
        updateCatalogProductsContainer(catalogContainer, data);
        // update misc catalog items via ajax
        return fetch(getCatalogTitleUrl + "&" + ajaxData)
          .then((response) => response.text())
          .then((data) => {
            const oldPageTitle = document.querySelector(".page-title");
            // update page title
            oldPageTitle.outerHTML = data;
            const newPageTitle = document.querySelector(".page-title");
            // update breadcrumbs
            const oldLastBreadcrumb = document.querySelector(
              ".breadcrumb ul li:last-child"
            );
            // check for product type updates
            const filterSidebar = document.querySelector(".filter-aside");
            const filtersSelected =
              filterSidebar.querySelectorAll(
                ".productTypes input[type=checkbox]:checked"
              ).length > 0 ||
              filterSidebar.querySelectorAll(
                ".mattressSizes input[type=checkbox]:checked"
              ).length > 0;

            if (oldLastBreadcrumb) {
              if (oldLastBreadcrumb.classList.contains("dynamic")) {
                if (filtersSelected) {
                  // product types are already selected, update text
                  oldLastBreadcrumb.textContent = newPageTitle.textContent;
                } else {
                  // product types are NOT selected, remove last breadcrumb
                  oldLastBreadcrumb.remove();
                }
              } else if (filtersSelected) {
                // add new li
                const newLi = document.createElement("li");
                newLi.classList.add("dynamic");
                newLi.textContent = newPageTitle.textContent;
                oldLastBreadcrumb.after(newLi);
              }
            }
            // update meta tags
            const oldTitle = document.querySelector("head title");
            const newTitle = oldTitle.textContent.replace(
              oldPageTitle.textContent,
              newPageTitle.textContent
            );
            oldTitle.textContent = newTitle;
            // Not every page renders a meta description (e.g. Shop All when
            // getMetaTags() falls back to an empty one) - guard instead of
            // throwing and aborting the rest of this chain.
            const oldDescription = document.querySelector(
              'head meta[name="description"]'
            );
            if (oldDescription) {
              const newDescription = oldDescription
                .getAttribute("content")
                .replace(oldPageTitle.textContent, newPageTitle.textContent);
              oldDescription.setAttribute("content", newDescription);
            }
            const ogTitle = document.querySelector(
              'head meta[property="og:title"]'
            );
            if (ogTitle) {
              ogTitle.setAttribute("content", newTitle);
            }
          });
      }),
  ];

  if (!skipFilters) {
    // update filter container via ajax - not needed for pagination/sort/
    // items-per-page, none of which change setFilters or the facet options
    catalogRequests.push(
      fetch(getFiltersUrl + "&" + ajaxData)
        .then((response) => response.text())
        .then((data) => {
          if (data.length) applySidebarFiltersHtml(data);
        })
    );
  }

  Promise.all(catalogRequests)
    .catch((error) => {
      console.error("Error:", error);
    })
    .finally(() => {
      catalogModal();
      hideLoadingOverlay();
      handleSortingBarChange();
      loadATPWidgetData();
    });
}

// Shared by fetchCatalogCount(), fetchDeferredFacets(), fetchProductListing() —
// derives the page/category pair each AJAX action's page=/category= params
// expect, from the URL path alone. loadProductCatalog() keeps its own inline
// copy (it has a rawPage === "search" special case the others don't need).
function getCatalogPageContext() {
  const pageSplit = window.location.pathname.split("/");
  const currentPage = pageSplit[pageSplit.length - 1];
  const rawPage =
    currentPage.length !== 0 ? currentPage.replace("shop-", "") : "index";
  const category =
    pageSplit[1] && pageSplit[1].includes("shop-")
      ? pageSplit[1].replace("shop-", "") === "all"
        ? ""
        : pageSplit[1].replace("shop-", "")
      : "";
  return { rawPage, category };
}

// Fills in the total result count and pagination once available, for
// catalog pages where displayCatalog() rendered them as pending (see
// .catalogCountPending / getCatalogCountFragment()) rather than computing
// the count synchronously with the product listing.
function fetchCatalogCount() {
  const pending = document.querySelector(".catalogCountPending");
  if (!pending) return;

  const { rawPage, category } = getCatalogPageContext();

  const url =
    globalObject.url +
    "ajax/product-catalog.php?action=getCatalogCount&page=" +
    rawPage +
    "&category=" +
    category;
  const query = window.location.search
    ? window.location.search.substring(1)
    : "";

  fetch(url + (query ? "&" + query : ""))
    .then((response) => response.text())
    .then((html) => {
      if (!html || !html.trim().length) return;

      const parsed = document.createElement("div");
      parsed.innerHTML = html;
      const countBlock = parsed.querySelector(".asyncCatalogCount");
      const paginationBlock = parsed.querySelector(".pagination");

      const mobileResults = pending.querySelector(".mobileResults");
      const desktopResults = pending.querySelector(".desktopResults");
      if (countBlock && mobileResults && desktopResults) {
        mobileResults.innerHTML =
          countBlock.querySelector(".mobileResults").innerHTML;
        desktopResults.innerHTML =
          countBlock.querySelector(".desktopResults").innerHTML;
      }
      pending.classList.remove("catalogCountPending");

      const catalogProductsContainer = document.querySelector(
        ".catalogProductsContainer"
      );
      if (paginationBlock && catalogProductsContainer) {
        const existingPagination =
          catalogProductsContainer.querySelector(".pagination");
        if (existingPagination) {
          existingPagination.outerHTML = paginationBlock.outerHTML;
        } else {
          catalogProductsContainer.appendChild(paginationBlock);
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
      pending.classList.remove("catalogCountPending");
    });
}

// Re-binds filter-sidebar interactivity (checkbox clicks, range sliders).
// Shared by initializeAccordion()'s post-load pass and fetchDeferredFacets(),
// which needs it too since a deferred facet's slider/checkbox markup doesn't
// exist in the DOM until its content is filled in.
function reinitializeFilterUI() {
  if (!document.querySelector(".filter-aside")) return;
  // Re-reads initial{Price,Width,Height,Depth}SliderValues from the DOM.
  productFilters.init();
  productFilters.bindClicks();
  productFilters.updateClearFiltersLink();
  productFilters.updateGroupSelect();
  productFilters.hideDuplicateFilters();
  productFilters.hideDuplicateExitFilters();
  productFilters.checkIfPriceFiltersSet();
  productFilters.initPriceFilterSlider();
  productFilters.initPriceInputChange();
  productFilters.checkIfWidthFiltersSet();
  productFilters.initWidthFilterSlider();
  productFilters.initWidthInputChange();
  productFilters.checkIfHeightFiltersSet();
  productFilters.initHeightFilterSlider();
  productFilters.initHeightInputChange();
  productFilters.checkIfDepthFiltersSet();
  productFilters.initDepthFilterSlider();
  productFilters.initDepthInputChange();
}

// Incremented whenever a real filter interaction replaces the sidebar DOM
// (see the getFilters handler in loadProductCatalog()) — lets a slower
// fetchDeferredFacets() response recognize it's stale and discard itself.
let filterGeneration = 0;

// Swaps a getFilters response's full .filter-aside markup in, preserving
// expanded-accordion and mobile-open state. Shared by loadProductCatalog()
// and fetchFiltersFullSwap(). bumpGeneration is false for the latter since
// it isn't a user interaction and runs alongside fetchProductListing(),
// which uses the same counter to detect a real change racing ahead of it.
function applySidebarFiltersHtml(data, bumpGeneration = true) {
  // get list of accordions currently expanded
  const expanded = [];
  const accordions = document.querySelectorAll(".accordion-header");
  accordions.forEach((accordion) => {
    if (accordion.classList.contains("ui-state-active")) {
      expanded.push(accordion.getAttribute("id"));
    }
  });

  // update filter container
  const filterAside = document.querySelector(".filter-aside");
  const wasOpenOnMobile = filterAside.classList.contains("slide");
  const parent = filterAside.parentNode;
  let newElement = document.createElement("div");
  newElement.innerHTML = data;
  newElement = newElement.firstChild;
  parent.replaceChild(newElement, filterAside);
  newElement.style.display = "block";

  // The new element is parsed fresh from the server response, so it
  // never carries the "slide" (mobile open) state - reapply it,
  // otherwise selecting a filter while the mobile sidebar is open
  // makes it snap closed out from under the user.
  if (wasOpenOnMobile) {
    newElement.classList.add("slide");
    newElement.style.left = "0";
  }

  // Real filter interactions bump this so a slower pending fetch discards
  // itself as stale.
  if (bumpGeneration) filterGeneration++;

  // Re-read slider bounds from the freshly rendered markup.
  productFilters.init();

  initializeAccordion(false);

  // re-expand accordions
  const headers = document.querySelectorAll(".accordion-header");
  headers.forEach((header) => {
    expanded.forEach((expand, i) => {
      if (header.getAttribute("id") === expand) {
        const nextElement = header.nextElementSibling;
        if (
          nextElement &&
          nextElement.classList.contains("accordion-content") &&
          !header.classList.contains("ui-state-active")
        ) {
          nextElement.style.display = "block";
          header.click();
        }
      }
    });
  });
}

// Fills a pending sidebar via a full getFilters fetch (cross-filter-aware)
// instead of the zero-filters-only getDeferredFacets endpoint — used when
// the true first load already has filters selected.
function fetchFiltersFullSwap() {
  // Guards against Clear Filters (clickable during the shimmer window)
  // resolving before this fetch does.
  const requestGeneration = filterGeneration;
  const { rawPage, category } = getCatalogPageContext();
  const url =
    globalObject.url +
    "ajax/product-catalog.php?action=getFilters&page=" +
    rawPage +
    "&category=" +
    category;
  const query = window.location.search
    ? window.location.search.substring(1)
    : "";

  fetch(url + (query ? "&" + query : ""))
    .then((response) => response.text())
    .then((data) => {
      if (requestGeneration !== filterGeneration) return;
      if (data.length) applySidebarFiltersHtml(data, false);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Fills in every facet displayProductFilters() rendered as a pending
// placeholder. Branches on data-has-selected-filters: zero-filters loads
// use the cheap combined-query endpoint below; loads with filters already
// selected defer to fetchFiltersFullSwap().
function fetchDeferredFacets() {
  const pendingFacets = document.querySelectorAll(".filterGroup.facetPending");
  if (!pendingFacets.length) return;

  const filterAside = document.querySelector(".filter-aside");
  if (filterAside && filterAside.dataset.hasSelectedFilters === "1") {
    fetchFiltersFullSwap();
    return;
  }

  const requestGeneration = filterGeneration;
  const { rawPage, category } = getCatalogPageContext();

  const url =
    globalObject.url +
    "ajax/product-catalog.php?action=getDeferredFacets&page=" +
    rawPage +
    "&category=" +
    category;
  const query = window.location.search
    ? window.location.search.substring(1)
    : "";

  fetch(url + (query ? "&" + query : ""))
    .then((response) => response.json())
    .then((fragments) => {
      // Sidebar was already replaced by a real filter interaction — discard.
      if (requestGeneration !== filterGeneration) return;

      Object.entries(fragments).forEach(([key, html]) => {
        const wrapper = document.querySelector(
          '.filter-aside [data-facet="' + key + '"]'
        );
        if (!wrapper) return;
        const header = wrapper.querySelector(".accordion-header");
        const content = wrapper.querySelector(".accordion-content");
        if (!header || !content) return;

        if (html === null) {
          // Matches today's sync render for a facet with zero options.
          wrapper.innerHTML = "";
          wrapper.classList.remove("facetPending");
          return;
        }

        const wasExpanded = header.classList.contains("ui-state-active");
        content.innerHTML = html;
        wrapper.classList.remove("facetPending");
        if (wasExpanded) {
          // The shimmer's height won't match the real content's.
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });

      reinitializeFilterUI();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

// Swaps only the product cards from a loadProductCatalog response into
// catalogContainer. The count/pagination area (.sortBySectionWrapper, and
// .pagination once fetchCatalogCount() resolves it) belongs to that separate,
// parallel fetch, not this response.
function updateCatalogProductsContainer(catalogContainer, responseHtml) {
  const parsedResponse = document.createElement("div");
  parsedResponse.innerHTML = responseHtml;

  // Only category's deferred-count listing responses carry a
  // catalogCountPending placeholder - other pages (e.g. search) render their
  // real sort/count bar synchronously here instead, outside
  // .catalogProductsContainer, so the narrowed swap below would silently
  // discard it.
  if (!parsedResponse.querySelector(".catalogCountPending")) {
    catalogContainer.outerHTML = responseHtml;
    return;
  }

  const catalogProductsContainer = catalogContainer.querySelector(
    ".catalogProductsContainer"
  );
  const newProductsContainer = parsedResponse.querySelector(
    ".catalogProductsContainer"
  );

  if (!catalogProductsContainer || !newProductsContainer) {
    catalogContainer.outerHTML = responseHtml;
    return;
  }

  const currentPagination =
    catalogProductsContainer.querySelector(".pagination");
  const resolvedPaginationHtml =
    currentPagination &&
    !currentPagination.classList.contains("paginationPending")
      ? currentPagination.outerHTML
      : null;

  catalogProductsContainer.innerHTML = newProductsContainer.innerHTML;
  catalogContainer.classList.remove("catalogProductsPending");

  if (resolvedPaginationHtml) {
    const freshPagination =
      catalogProductsContainer.querySelector(".pagination");
    if (freshPagination) {
      freshPagination.outerHTML = resolvedPaginationHtml;
    }
  }
}

// Repaints the current product grid with the same shimmer skeleton
// displayCatalogPending() renders on first load. Card markup mirrors
// displayCatalogPending()'s PHP output exactly so no new CSS is needed.
// Card count matches whatever's currently on screen, so the grid doesn't
// visibly resize.
function showListingShimmer() {
  const catalogContainer = document.querySelector(
    ".catalogProductDisplay > .catalogContainer"
  );
  const productsContainer = document.querySelector(".catalogProductsContainer");
  if (!catalogContainer || !productsContainer) return;

  const cardCount =
    productsContainer.querySelectorAll(".catalogItem").length || 24;
  let cardsHtml = "";
  for (let i = 0; i < cardCount; i++) {
    cardsHtml +=
      '<div class="catalogItem col-6 col-sm-4 shimmerCard">' +
      '<div class="itemBox">' +
      '<div class="shimmerBlock shimmerImage"></div>' +
      '<div class="shimmerBlock shimmerTitle"></div>' +
      '<div class="shimmerBlock shimmerPrice"></div>' +
      "</div></div>";
  }

  let paginationHtml = '<ul class="pagination paginationPending">';
  for (let i = 0; i < 7; i++) {
    paginationHtml += "<li></li>";
  }
  paginationHtml += "</ul>";

  catalogContainer.classList.add("catalogProductsPending");
  productsContainer.innerHTML = cardsHtml + paginationHtml;

  // Marks the top result-count bar pending too, so it shimmers in step with
  // the grid above.
  const sortBySectionWrapper = catalogContainer.querySelector(
    ".sortBySectionWrapper"
  );
  if (sortBySectionWrapper) {
    sortBySectionWrapper.classList.add("catalogCountPending");
  }
}

// Repaints every currently-expanded facet's content with the same shimmer
// markup displayProductFilters() renders for a facet still pending its
// deferred fetch (.facetPending/.facetShimmer) - collapsed facets are left
// alone since their content isn't visible anyway.
function showFilterAsideShimmer() {
  document.querySelectorAll(".filter-aside .filterGroup").forEach((group) => {
    const header = group.querySelector(".accordion-header");
    const content = group.querySelector(".accordion-content");
    if (!header || !content || !header.classList.contains("ui-state-active")) {
      return;
    }
    content.innerHTML =
      '<ul class="facetShimmer overflow"><li></li><li></li><li></li></ul>';
    group.classList.add("facetPending");
  });
}

// Fills in the real product listing for the true first page load, where
// displayCatalogPending() left it as a shimmer placeholder
// (.catalogProductsPending). Reuses the loadProductCatalog AJAX action
// unchanged - the same one filter changes already use - and swaps
// .catalogContainer the same way loadProductCatalog() itself does.
function fetchProductListing() {
  const pending = document.querySelector(".catalogProductsPending");
  if (!pending) return;

  const requestGeneration = filterGeneration;
  const { rawPage, category } = getCatalogPageContext();
  const query = window.location.search
    ? window.location.search.substring(1)
    : "";

  const url =
    globalObject.url +
    "ajax/product-catalog.php?action=loadProductCatalog&page=" +
    rawPage +
    "&category=" +
    category;

  fetch(url + (query ? "&" + query : ""))
    .then((response) => response.text())
    .then((data) => {
      // A real filter interaction already replaced this - discard.
      if (requestGeneration !== filterGeneration) return;

      const catalogContainer = document.querySelector(
        ".catalogProductDisplay > .catalogContainer"
      );
      if (!catalogContainer) return;

      updateCatalogProductsContainer(catalogContainer, data);

      catalogModal();
      handleSortingBarChange();
      loadATPWidgetData();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function initializeAccordion(click = true) {
  // Must bind before the setTimeout below - filter content can already be
  // real and interactive by the time this runs.
  reinitializeFilterUI();

  setTimeout(function () {
    // Click-based fallback for pages that don't server-render these
    // accordions already expanded (search::displayProductFilters()) —
    // remove once that's gone too.
    // the categories filter is not always present, so productTypes is the fallback
    const initialFiltersToExpand = [
      "accordion-availability",
      "accordion-locations",
      "accordion-categories",
      "accordion-productTypes",
    ];
    let filtersToClick = [];
    let filtersExpandedBool = [];
    const maxFiltersToExpand = 3;
    let count = 0;

    // loop through initial filters to expand and check if they are already expanded
    initialFiltersToExpand.forEach(function (filter) {
      const filterDiv = document.getElementById(filter);
      if (filterDiv && count < maxFiltersToExpand) {
        const isExpanded = filterDiv.classList.contains("ui-state-active");
        filtersExpandedBool.push(isExpanded);
        if (!isExpanded) {
          filtersToClick.push(filter);
        }
        count++;
      }
    });

    // ensure that all filters are collapsed
    const allExpandedFiltersCollapsed = filtersExpandedBool.every(
      (val) => val === false
    );

    // if all filters are collapsed, click on the filter elements to expand them
    if (allExpandedFiltersCollapsed) {
      filtersToClick.forEach(function (filter) {
        let filterDiv = document.getElementById(filter);
        if (filterDiv) {
          filterDiv.click();
        }
      });
    }
  }, 500);

  // Get all accordion elements
  let accordions = Array.from(document.querySelectorAll(".accordion"));

  accordions.forEach((accordion) => {
    let header = accordion.querySelector("h2.accordion-header");
    let content = accordion.querySelector(".accordion-content");
    if (!header || !content) return;

    // Initially hide the content
    if (!content.classList.contains('open')) {
      content.style.maxHeight = "0";
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
      header.classList.add("ui-state-active");
    }
    content.style.overflow = "hidden";
    content.style.transition = "max-height 0.3s ease-out";

    // Add click event listener to the header
    header.addEventListener("click", function () {
      if (content.style.maxHeight !== "0px") {
        content.style.maxHeight = "0";
        header.classList.remove("ui-state-active");
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
        header.classList.add("ui-state-active");
      }
    });
  });

  // Check if filter-aside exists
  if (document.querySelector("#filter-aside")) {
    accordions.forEach((accordion) => {
      let header = accordion.querySelector("h2.accordion-header");
      let accordionId = header.getAttribute("id");
      if (accordionId) {
        let filter = accordionId.replace("accordion-", "");
        if (getUrlParameter(filter + "[]")) {
          let content = header.nextElementSibling;
          content.style.maxHeight = content.scrollHeight + "px";
          if (click) {
            header.click();
          }
        }
      }
    });
  }
}

function expandAccordion(el) {
  if (!el.classList.contains("ui-state-active")) {
    el.click();
  }
}

function openDimensionsTab() {
  const tabsWrapper = document.querySelector("#product-info-tabs");
  const dimensionsButton = document.querySelector("#dimensions-tab-btn");

  if (tabsWrapper && dimensionsButton) {
    // Click the dimensions tab button to open it
    dimensionsButton.click();

    // Scroll to the tabs section after brief delay to allow tab switching
    setTimeout(function () {
      window.scrollTo({
        top: tabsWrapper.offsetTop + 100,
        behavior: "smooth",
      });
    }, 150);
  }
}

function getUrlParameter(name) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)", "g");
  var regexResults = decodeURI(location.search).match(regex);
  return regexResults !== null
    ? regexResults
        .slice(-1)[0]
        .match(/=([^&#]*)/)[0]
        .replace("=", "")
    : "";
}

function formatPhone(phone) {
  var cleaned = ("" + phone).replace(/\D/g, "");
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return "(" + match[1] + ") " + match[2] + "-" + match[3];
  } else {
    var match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return "(" + match[2] + ") " + match[3] + "-" + match[4];
    }
  }
  return phone;
}

function unformatPhone(phone) {
  return phone.replace(/\(|\)|\s|-/, phone);
}

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return false;
}

function updateURLParameter(url, param, paramVal) {
  // Create a new URL object
  let urlObj = new URL(url);

  // Get the search parameters from the URL
  let searchParams = urlObj.searchParams;

  // Update the parameter
  searchParams.set(param, paramVal);

  // Update the search parameters of the URL
  urlObj.search = searchParams.toString();

  // Return the updated URL
  return urlObj.toString();
}

async function getCallUsSlidePanel() {
  try {
    const response = await fetch(globalObject.url + "ajax/locator.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        action: "displayCallUsSlidePanel",
      }),
    });
    const data = await response.text();
    document.querySelector("body").insertAdjacentHTML("beforeend", data);
    return document.querySelector("#callUsSlidePanel");
  } catch (error) {
    console.error("Error:", error);
    return null;
  }
}

async function toggleSlidePanel(panelId, direction) {
  let panel = document.querySelector(panelId);
  if (!panel) {
      panel = await getCallUsSlidePanel();    
      if (!panel) return;
  }

  const closeBtn = panel.querySelector(".close-btn");
  const focusableEls = panel.querySelectorAll(
    'a[href], button, textarea, input[type="text"], input[type="email"], input[type="tel"], input[type="radio"], input[type="checkbox"], select'
  );
  if (direction == "open") {
    focusableEls.forEach((el) => {
      el.tabIndex = 1;
    });
    //Show panel
    document.body.classList.add("slidePanel-showing", "darken");
    panel.classList.add("revealed");
    const elem = document.createElement("div");
    elem.id = "closePanelUnderlay";
    panel.parentNode.insertBefore(elem, panel.nextSibling);

    elem.addEventListener("click", handleClick);
    closeBtn.addEventListener("click", handleClick);
    document.addEventListener("keydown", handleFocus);
    closeBtn.focus();
  } else if (direction == "close") {
    focusableEls.forEach((el) => {
      el.tabIndex = -1;
    });
    //Show panel. If panel is visible, hide
    document.body.classList.remove("slidePanel-showing", "darken");
    panel.classList.remove("revealed");
    const underlay = document.getElementById("closePanelUnderlay");

    document.removeEventListener("keydown", handleFocus);
    underlay.remove();
  }

  function handleClick() {
    toggleSlidePanel(panelId, "close");
    closeBtn.removeEventListener("click", handleClick);
    document.removeEventListener("keydown", handleFocus);
  }

  function handleFocus(e) {
    if (e.keyCode === 9 && panel.classList.contains("revealed")) {
      // checking if element is textarea because e.preventDefault() will trap you in it
      document.activeElement.tagName.toLowerCase() != "textarea" &&
        e.preventDefault();
      const focusable = [...focusableEls];
      const index = focusable.indexOf(document.activeElement);

      nextIndex = index + 1 < focusable.length ? index + 1 : 0;
      focusableEls[nextIndex].focus({ focusVisible: true });
    } else if (e.keyCode === 27 && panel.classList.contains("revealed")) {
      toggleSlidePanel(panelId, "close");
      document.removeEventListener("keydown", handleFocus);
    } else if (!panel.classList.contains("revealed")) {
      document.removeEventListener("keydown", handleFocus);
    }
  }
}

function closeSlidePanel(panel) {
  document.body.classList.remove("slidePanel-showing", "darken");
  panel.classList.remove("revealed");
  const underlay = document.getElementById("closePanelUnderlay");
  underlay.remove();
}

// function closeModal(modal) {
//   if (modal.parents(".blocker").is(":visible")) {
//     modal.parents(".blocker").removeClass("show").hide().addClass("hide");
//   }
// }

// TODO: Move to vanilla JS
function loadingButton(action, button) {
  let buttonText = "";
  switch (action) {
    case "loading":
      //Button is currently loading
      buttonText = button.html();
      buttonWidth = button.outerWidth();
      button.data("text", buttonText);
      button
        .addClass("loading")
        .attr("disabled", true)
        .html('<i class="fas fa-circle-notch fa-spin"></i>')
        .css("width", buttonWidth);
      break;
    case "done":
      //Button is done loading
      buttonText = button.data("text");
      button
        .removeClass("loading")
        .attr("disabled", false)
        .html(buttonText)
        .css("width", "unset");
      break;
  }
}

function getSVGIcon(icon, classes, placement, replace = false) {
  const url = new URL(globalObject.url + "ajax/product-catalog.php");
  url.search = new URLSearchParams({
    action: "getSVGIcon",
    icon: icon,
    classes: classes,
  });

  fetch(url, { method: "GET" })
    .then((response) => response.text())
    .then((response) => {
      let placementElement;
      if (typeof placement === "string") {
        placementElement = document.querySelector(placement);
      } else {
        placementElement = placement;
      }

      if (!placementElement) return;

      if (replace) {
        const div = document.createElement("div");
        div.innerHTML = response;
        placementElement.replaceWith(...div.childNodes);
      } else {
        placementElement.insertAdjacentHTML("beforeend", response);
      }
    })
    .catch((error) => {
      console.error("getSVGIcon error:", error);
    });
}

// TODO: Move to vanilla JS
async function getSVGIconNEW(icon, classes = "") {
  const result = await $.ajax({
    data: { action: "getSVGIcon", icon: icon, classes: classes },
    type: "GET",
    url: globalObject.url + "ajax/product-catalog.php",
    dataType: "text",
  });
  return result;
}

// TODO: Move to vanilla JS
function pushToDataLayerProductClick(step, variant) {
  $.ajax({
    data: "step=" + step + "&variant=" + variant,
    type: "POST",
    url: globalObject.url + "ajax/ecommerce.php?action=generateDataLayer",
    dataType: "text",
    success: function (response) {
      let data = JSON.parse(response);
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(data);
    },
  });
}

// function added to replace jquery elem.is(":visible")
function isVisible(e) {
  return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
}

document.querySelectorAll(".tab-item").forEach((tab) => {
  if (tab) tab.addEventListener("click", changeTab);
});

const tabs = document.getElementById("tabs");

if (tabs)
  tabs.addEventListener("input", function (e) {
    const tabId = e.target.selectedOptions[0].dataset.tab;
    const tabContent = document.querySelector(`[data-tab-content="${tabId}"]`);
    const tabContentParent = tabContent.parentNode;
    const tabContentSiblings = tabContentParent.querySelectorAll(".panel");
    const tabSiblings = tabContentParent.querySelectorAll(".tab-item");

    tabSiblings.forEach((sibling) => {
      sibling.classList.remove("active");
    });

    tabContentSiblings.forEach((sibling) => {
      sibling.classList.remove("active");
    });

    tabContent.classList.add("active");
  });

// a vanilla js function to change tabs using data attributes
function changeTab(e) {
  const tab = e.target;
  const tabId = tab.dataset.tab;
  const tabContent = document.querySelector(`[data-tab-content="${tabId}"]`);
  const tabContentParent = tabContent.parentNode;
  const tabContentSiblings = tabContentParent.querySelectorAll(".panel");
  const tabSiblings = tab.parentNode.querySelectorAll(".tab-item");

  tabSiblings.forEach((sibling) => {
    sibling.classList.remove("active");
  });
  tabContentSiblings.forEach((sibling) => {
    sibling.classList.remove("active");
  });

  tab.classList.add("active");
  tabContent.classList.add("active");
}

// Create a modal pop-up
function displayModal(modalContent) {
  const overlay = document.createElement("div");
  overlay.classList.add("window-overlay");

  overlay.innerHTML = modalContent;
  const closeBtn = document.createElement("div");
  closeBtn.role = "button";
  closeBtn.innerHTML = `
 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#ffffff" viewBox="0 0 256 256"><path d="M208.49,191.51a12,12,0,0,1-17,17L128,145,64.49,208.49a12,12,0,0,1-17-17L111,128,47.51,64.49a12,12,0,0,1,17-17L128,111l63.51-63.52a12,12,0,0,1,17,17L145,128Z"></path></svg>
  `;

  closeBtn.classList.add("close-modal-btn");

  const modal = overlay.querySelector(".modal");
  if (modal) {
    modal.appendChild(closeBtn);
    closeBtn.addEventListener("click", () => removeModal());
  }

  document.body.appendChild(overlay);
  overlay.addEventListener("click", (e) => {
    if (e.target.classList.contains("window-overlay")) {
      overlay.remove();
    }
  });
}

function removeModal() {
  const overlay = document.querySelector(".window-overlay");
  if (overlay) overlay.remove();
}

function handleCloseModal() {
  document.body.addEventListener("click", (e) => {
    let modal = null;
    let classes = e.target.classList;
    if (classes.contains("blocker", "show")) {
      modal = e.target;
    } else if (classes.contains("close-modal")) {
      modal = e.target.closest(".blocker");
    }

    if (modal) {
      modal.classList.remove("show");
      modal.classList.add("hide");
    }
  });
}

function showModal(e, id = null) {
  modal = id ? document.getElementById(id) : e.target.nextElementSibling;
  if (modal && modal.classList.contains("blocker")) {
    modal.classList.remove("hide");
    modal.classList.add("show");
    modal.style.display = "block";

    modal.addEventListener("click", (e) => {
      if (
        e.target.classList.contains("blocker") ||
        e.target.classList.contains("close-modal")
      ) {
        modal.classList.remove("show");
        modal.classList.add("hide");
      }
    });
  }
}

function closeModal(modalId) {
  const modal = document.getElementById(modalId);
  if (modal) {
    modal.classList.remove("show");
    modal.classList.add("hide");
  }
}

function updateStructuredData(pageType) {
  const globalVariableName = "V5_STRUCTURED_DATA";
  const url = new URL(window.location.origin+"/ajax/product-catalog.php");
  url.search = new URLSearchParams({
    action: "getStructuredData",
    pageType: pageType,
  });

  fetch(url,
    { method: "GET" },
  )
  .then((response) => response.json())
  .then((response) => {
    window[globalVariableName] = response;
  })
  .catch((error) => {
    console.error("Error:", error);
  });
}

/**
 * Lazy load ATP widget availability data for catalog pages. Collects all
 * placeholder SKUs and makes a single batch AJAX request; server resolves the
 * matching `atpWidgetConfigs` row per product.
 */
let atpAbortController = null;

function loadATPWidgetData() {
  // Cancel any in-flight ATP request (prevents stale responses from overwriting newer data)
  if (atpAbortController) {
    atpAbortController.abort();
  }
  atpAbortController = new AbortController();
  const placeholders = document.querySelectorAll('.atp-widget--placeholder');
  if (placeholders.length === 0) return;

  // Collect product info and map to placeholder elements
  // Use a composite key for products without SKU (sku + index)
  const productMap = new Map();
  const products = [];
  let noSkuIndex = 0;

  placeholders.forEach(el => {
    const sku = el.dataset.sku || '';
    const inStock = el.dataset.inStock === '1';
    const ecommerce = el.dataset.ecommerce === '1';
    const brandId = parseInt(el.dataset.brandId, 10) || 0;
    const brandBridgeId = parseInt(el.dataset.brandBridgeId, 10) || 0;
    const inventoryType = parseInt(el.dataset.inventoryType, 10) || 0;

    // Create a unique key - for empty SKUs, use index to differentiate
    const key = sku ? `${brandId}_${sku}` : `__nosku_${noSkuIndex++}`;

    if (!productMap.has(key)) {
      productMap.set(key, []);
      products.push({
        sku: sku,
        key: key,
        inStock: inStock,
        ecommerce: ecommerce,
        brandId: brandId,
        brandBridgeId: brandBridgeId,
        inventoryType: inventoryType
      });
    }
    productMap.get(key).push(el);
  });

  if (products.length === 0) return;

  // Make single batch request with product info
  fetch('/ajax/product-catalog.php?action=getATPWidget', {
    method: 'POST',
    signal: atpAbortController.signal,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: 'products=' + encodeURIComponent(JSON.stringify(products))
  })
  .then(response => response.json())
  .then(results => {
    // Populate all placeholders with ATP data
    productMap.forEach((elements, key) => {
      const data = results[key];
      elements.forEach(el => {
        el.classList.remove('atp-widget--placeholder');
        el.innerHTML = (data && data.html) ? data.html : '';
      });
    });
  })
  .catch((err) => {
    if (err.name === 'AbortError') return; // Intentional cancellation, new request in progress
    // Remove placeholder class on error to clean up UI
    placeholders.forEach(el => {
      el.classList.remove('atp-widget--placeholder');
    });
  });
}

/**
 * Toggle the ATP product-page widget between its two states based on the
 * currently selected quantity. When the customer picks more than local stock
 * can satisfy, swap from "Get it Today" to the ETA message.
 */
// Obfuscation key for the masked qty thresholds in data-atp-q. NOT a secret —
// just keeps raw inventory counts out of the DOM. Must match
// ATPWidget::QTY_MASK_KEY in core/atp/ATPWidget.php.
const ATP_QTY_MASK_KEY = 'aTp~v5~qTy~m4sk';

// Reverse ATPWidget::maskQty(): base64 → [nonce(4)][cipher] → "localQty:apiQty".
function atpUnmaskQty(token) {
  let raw;
  try { raw = atob(token); } catch (e) { return [0, 0]; }
  if (raw.length < 5) return [0, 0];

  const nonce = raw.slice(0, 4);
  const cipher = raw.slice(4);
  let payload = '';
  for (let i = 0; i < cipher.length; i++) {
    payload += String.fromCharCode(
      cipher.charCodeAt(i)
      ^ ATP_QTY_MASK_KEY.charCodeAt(i % ATP_QTY_MASK_KEY.length)
      ^ nonce.charCodeAt(i % 4)
    );
  }

  const parts = payload.split(':');
  return [parseInt(parts[0], 10) || 0, parseInt(parts[1], 10) || 0];
}

function initATPWidgetQtyToggle() {
  const widget = document.querySelector('.atp-widget[data-atp-q]');
  const qtySelect = document.getElementById('productQuantity');
  if (!widget || !qtySelect) return;

  const localState = widget.querySelector('.atp-widget__message--local');
  const etaState = widget.querySelector('.atp-widget__message--eta');
  const unknownState = widget.querySelector('.atp-widget__message--unknown');

  // Need at least two states for the qty selection to change anything.
  const states = [localState, etaState, unknownState].filter(Boolean);
  if (states.length < 2) return;

  const [localQty, apiQty] = atpUnmaskQty(widget.dataset.atpQ);
  const etaCeiling = localQty + apiQty; // local stock + what the vendor can promise

  const update = () => {
    const selectedQty = parseInt(qtySelect.value, 10) || 0;

    let active;
    if (localState && selectedQty <= localQty) {
      active = localState;                       // ships today from local stock
    } else if (etaState && selectedQty <= etaCeiling) {
      active = etaState;                         // vendor can fulfill by the ETA date
    } else {
      active = unknownState || etaState || localState; // beyond promise → contact us
    }

    states.forEach((el) => { el.hidden = el !== active; });
    widget.classList.toggle('atp-widget--local', active === localState);
  };

  qtySelect.addEventListener('change', update);
  update();
}